Code
<template>
  <div class="col-md-12 ml-sm-auto col-lg-12 px-4">
    <v-main>
      <left-menu-admin :boolenAlert="boolenAlert" />
      <v-row>
        <v-col cols="6" class="text-left"> </v-col>
        <v-col cols="6" class="v-margit_button text-right">
          <v-btn color="#1B437C" depressed dark @click="dialogAdd = true">
            <v-icon left>mdi-text-box-plus</v-icon>
            เพิ่มของรางวัล
          </v-btn>
        </v-col>
      </v-row>
      <v-dialog
        v-model="dialogChangeExpire"
        style="border-radius: 0px !important"
        width="300"
      >
        <v-date-picker
          v-model="pickerChangeExpire"
          style="border-radius: 0px !important"
          color="rgb(28 67 124)"
          locale="th-th"
        ></v-date-picker>
        <div>
          <v-btn
            color="green"
            block
            style="color: white !important"
            @click="changExpirePackage()"
            ><v-icon>mdi-calendar-clock</v-icon>เปลี่ยนวันหมดอายุ</v-btn
          >
        </div>
      </v-dialog>
      <v-row>
        <!-- ADD -->
        <v-dialog v-model="dialogAdd" persistent max-width="800px">
          <v-card class="pa-5">
            <v-card-title>
              <span class="text-h5">เพิ่มของรางวัล</span>
              <!-- {{ formAdd.supply }}
              {{ steped }} -->
              <v-spacer></v-spacer>
              <v-btn
                icon
                @click="
                  steped = 1,(dialogAdd = false),clear()
                "
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>

            <v-card-text>
              <v-stepper v-model="steped" elevation="0" flat>
                <v-stepper-header>
                  <v-stepper-step :complete="steped > 1" step="1"
                    >ประเภทของรางวัล</v-stepper-step
                  >

                  <v-divider></v-divider>

                  <v-stepper-step :complete="steped > 2" step="2"
                    >ข้อมูลของรางวัล</v-stepper-step
                  >

                  <v-divider></v-divider>

                  <v-stepper-step :complete="steped >= 3" step="3"
                    >เงื่อนไขการรับของรางวัล</v-stepper-step
                  >
                </v-stepper-header>

                <v-stepper-items>
                  <v-stepper-content step="1">
                    <h3>ประเภทของรางวัล</h3>
                    <v-row>
                      <v-col
                        cols="12"
                        sm="12"
                        md="6"
                        lg="6"
                        v-for="i in selectType"
                        :key="i.name"
                      >
                        <v-card
                          elevation="0"
                          outlined
                          rounded
                          :style="{
                            border:
                              formAdd.supply === i.value
                                ? '2px solid #1C3051'
                                : '1px solid #ccc',
                          }"
                          @click="
                            (formAdd.supply = i.value), onSelectSuply(i.value)
                          "
                        >
                          <div
                            class="d-flex justify-center align-center flex-column"
                            style="height: 120px"
                          >
                            <v-icon>
                              {{ i.icon }}
                            </v-icon>
                            <h4>{{ i.text }}</h4>
                          </div>
                        </v-card>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" class="text-end">
                        <v-btn
                          dark
                          :color="btnContinue"
                          @click="onNextStep(2, 'add')"
                        >
                          ต่อไป
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-stepper-content>

                  <v-stepper-content step="2">
                    <h3>ข้อมูลของรางวัล</h3>
                    <v-form ref="formStep2">
                      <v-row>
                        <v-col cols="12" class="pb-0">
                          <v-img
                            aspect-ratio="6"
                            contain
                            :src="formAdd.pictureUrl"
                            v-if="formAdd.pictureUrl"
                          ></v-img>
                          <br />
                          <v-file-input
                            v-model="filesAdd"
                            outlined
                            dense
                            required
                            counter
                            show-size
                            :rules="[
                              rules.required,
                              rules.imageType,
                              rules.fileSize,
                            ]"
                            accept="image/jpeg, image/jpg, image/png"
                            prepend-icon="mdi-camera"
                            label="รูปภาพของรางวัล"
                            @change="selectImg( 'add')"
                          ></v-file-input>
                        </v-col>
                        <v-col cols="12" md="12">
                          <p
                            style="
                              margin: 0px 15px;
                              font-size: small;
                              color: #adb5bd;
                            "
                          >
                            รูปแบบไฟล์: JPG, JPEG, PNG
                          </p>
                          <p
                            style="
                              margin: 0px 15px;
                              font-size: small;
                              color: #adb5bd;
                            "
                          >
                            ขนาดไฟล์: ไม่เกิน 10 MB
                          </p>
                          <p
                            style="
                              margin: 0px 15px;
                              font-size: small;
                              color: #adb5bd;
                            "
                          >
                            ขนาดภาพแนะนำ: 850 × 850 pixels
                          </p>
                        </v-col>
                        <v-col cols="12" md="6">
                          <v-text-field
                            v-model="formAdd.name"
                            label="ชื่อของรางวัลภาษาไทย"
                            outlined
                            dense
                            required
                            :rules="[rules.required]"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6">
                          <v-text-field
                            v-model="formAdd.nameEng"
                            label="ชื่อของรางวัลภาษาอังกฤษ"
                            outlined
                            dense
                            required
                            :rules="[rules.required]"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6">
                          <v-textarea
                            v-model="formAdd.description"
                            label="รายละเอียดภาษาไทย"
                            auto-grow
                            outlined
                            rows="3"
                            row-height="25"
                            :rules="[rules.required]"
                          ></v-textarea>
                        </v-col>
                        <v-col cols="12" md="6">
                          <v-textarea
                            v-model="formAdd.descriptionEng"
                            label="รายละเอียดภาษาอังกฤษ"
                            auto-grow
                            outlined
                            rows="3"
                            row-height="25"
                            :rules="[rules.required]"
                          ></v-textarea>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="" md="6" lg="6" class="text-start">
                          <v-btn
                            :color="btnBack"
                            outlined
                            @click="onNextStep(1, 'add')"
                          >
                            ย้อนกลับ
                          </v-btn>
                        </v-col>
                        <v-col cols="" md="6" lg="6" class="text-end">
                          <v-btn
                            dark
                            :color="btnContinue"
                            @click="onNextStep(3, 'add')"
                          >
                            ต่อไป
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-stepper-content>

                  <v-stepper-content step="3">
                    <h3>เงื่อนไขการรับของรางวัล</h3>
                    <v-form ref="formPointStep3">
                      <v-card
                        v-if="formAdd.supply === 'admin'"
                        v-for="setting in settingsReward"
                        :key="setting.levelName"
                        class="mb-5 pl-10 pr-10"
                        style="
                          border: 1px solid gray;
                          border-radius: 8px;
                          min-height: 70px;
                        "
                      >
                        <div
                          class="d-flex align-center justify-space-between"
                          style="min-height: 70px"
                        >
                          <div class="d-flex align-center">
                            <v-switch
                              v-model="setting.enabled"
                              inset
                              :label="setting.levelName"
                              hide-details
                            />
                          </div>
                          <!-- {{ i }} -->
                          <div class="d-flex align-center">
                            <v-text-field
                              v-model.number="setting.points"
                              label="คะแนนที่ใช้แลก *"
                              outlined
                              dense
                              hide-details
                              type="number"
                              style="max-width: 650px"
                              :rules="[
                                (v) =>
                                  v >= 0 || 'คะแนนต้องมากกว่าหรือเท่ากับ 0',
                              ]"
                            />
                          </div>
                        </div>
                      </v-card>
                    </v-form>

                    <div v-if="formAdd.supply !== 'admin' || ''">
                      <v-form ref="formStep3">
                        <v-row>
                          <v-col md="6">
                            <v-text-field
                              v-model="formAdd.point"
                              label="คะแนนที่ใช้แลก"
                              outlined
                              dense
                              required
                              type="number"
                              :rules="[rules.required,(v) =>
                                  v >= 0 || 'คะแนนต้องมากกว่าหรือเท่ากับ 0',]"
                            ></v-text-field>
                          </v-col>
                          <v-col md="6">
                            <v-text-field
                              v-model="formAdd.resale"
                              label="คะแนนช่วงโปรโมชั่น"
                              outlined
                              dense
                              required
                              type="number"
                              :rules="[
                                (v) =>
                                  v >= 0 || 'คะแนนต้องมากกว่าหรือเท่ากับ 0',
                              ]"
                            ></v-text-field>
                          </v-col>
                          <v-col md="6">
                            <v-select
                              v-model="formAdd.levelId"
                              :items="dataLevel"
                              label="ระดับสมาชิกที่แลกได้"
                              dense
                              outlined
                              :rules="[rules.required]"
                            ></v-select>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col
                            cols="12"
                            class="pt-0 pb-0"
                            v-if="formAdd.supply === 'รับหน้าร้าน'"
                          >
                            <v-checkbox
                              v-model="formAdd.showReward"
                              :label="`ใช้คะแนนแลกของรางวัล`"
                            ></v-checkbox>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col
                            cols="12"
                            class="pt-0 pb-0"
                            v-if="formAdd.supply === 'รับหน้าร้าน'"
                          >
                            <v-checkbox
                              v-model="checkboxLevelUpGiveReward"
                              :label="`แจกของรางวัลเมื่อสมาชิกเลื่อนระดับ`"
                            ></v-checkbox>
                          </v-col>
                        </v-row>
                        <v-row v-if="checkboxLevelUpGiveReward">
                          <v-col md="6" class="pt-0 pb-0">
                            <v-autocomplete
                              v-model="formAdd.dataLevelUpgrade"
                              :items="
                                dataLevel.filter(
                                  (item) => item.value !== 'allLevel',
                                )
                              "
                              outlined
                              dense
                              small-chips
                              label="ระดับสมาชิก"
                              multiple
                            ></v-autocomplete>
                          </v-col>
                          <v-col md="6" class="pt-0 pb-0">
                            <v-text-field
                              v-model="formAdd.amountToGive"
                              label="จำนวนที่ต้องการแจก"
                              outlined
                              dense
                              required
                              type="number"
                              suffix="ชิ้น"
                              :rules="
                                checkboxLevelUpGiveReward === true
                                  ? [rules.required,(v) =>
                                  v >= 0 || 'คะแนนต้องมากกว่าหรือเท่ากับ 0',]
                                  : ''
                              "
                            ></v-text-field>
                          </v-col>
                        </v-row>
                      </v-form>
                    </div>

                    <v-row>
                      <v-col cols="" md="6" lg="6" class="text-start">
                        <v-btn
                          :color="btnBack"
                          outlined
                          @click="onNextStep(2, 'add')"
                        >
                          ย้อนกลับ
                        </v-btn>
                      </v-col>
                      <v-col cols="" md="6" lg="6" class="text-end">
                        <v-btn
                          dark
                          :color="btnContinue"
                          :loading='loading'
                          @click="onSubmit('add')"
                        >
                          บันทึก
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-stepper-content>
                </v-stepper-items>
              </v-stepper>
            </v-card-text>
          </v-card>
        </v-dialog>

        <!-- edit -->
        <v-dialog
          v-model="dialogEdit"
          persistent
          max-width="800px"
          :fullscreen="resCol === '12' ? true : false"
        >
          <v-card class="pa-5">
            <v-card-title>
              <span class="text-h5">เพิ่มของรางวัล</span>
              <v-spacer></v-spacer>
              <v-btn icon @click="(dialogEdit = false), (steped = 1), clear()">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
            <!-- {{formUpdate}} -->

            <v-card-text>
              <v-stepper v-model="steped" elevation="0" flat>
                <v-stepper-header>
                  <v-stepper-step :complete="steped > 1" step="1"
                    >ประเภทของรางวัล</v-stepper-step
                  >

                  <v-divider></v-divider>

                  <v-stepper-step :complete="steped > 2" step="2"
                    >ข้อมูลของรางวัล</v-stepper-step
                  >

                  <v-divider></v-divider>

                  <v-stepper-step :complete="steped > 3" step="3"
                    >เงื่อนไขการรับของรางวัล</v-stepper-step
                  >
                </v-stepper-header>

                <v-stepper-items>
                  <v-stepper-content step="1">
                    <h3>ประเภทของรางวัล</h3>
                    <v-row>
                      <v-col
                        cols="12"
                        sm="12"
                        md="6"
                        lg="6"
                        v-for="i in selectType"
                        :key="i.name"
                      >
                        <v-card
                          elevation="0"
                          outlined
                          rounded
                          :style="{
                            border:
                              formUpdate.supply === i.value
                                ? '2px solid #1C3051'
                                : '1px solid #ccc',
                          }"
                          @click="
                            (formUpdate.supply = i.value),
                              onSelectSuply(i.value, 'edit')
                          "
                        >
                          <div
                            class="d-flex justify-center align-center flex-column"
                            style="height: 120px"
                          >
                            <v-icon>
                              {{ i.icon }}
                            </v-icon>
                            <h4>{{ i.text }}</h4>
                          </div>
                        </v-card>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" class="text-end">
                        <v-btn
                          dark
                          :color="btnContinue"
                          @click="onNextStep(2, 'edit')"
                        >
                          ต่อไป
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-stepper-content>

                  <v-stepper-content step="2">
                    <h3>ข้อมูลของรางวัล</h3>
                    <v-form ref="formStep2">
                      <v-row>
                        <v-col cols="12" class="pb-0">
                          <v-img
                            aspect-ratio="6"
                            contain
                            :src="formUpdate.pictureUrl"
                            v-if="formUpdate.pictureUrl"
                          ></v-img>
                          <br />
                          <v-file-input
                            v-model="filesUpdate"
                            outlined
                            dense
                            required
                            counter
                            show-size
                            accept="image/jpeg, image/jpg, image/png"
                            prepend-icon="mdi-camera"
                            label="รูปภาพของรางวัล"
                            @change="selectImg( 'edit')"
                          ></v-file-input>
                        </v-col>
                        <v-col cols="12" md="12">
                          <p
                            style="
                              margin: 0px 15px;
                              font-size: small;
                              color: #adb5bd;
                            "
                          >
                            รูปแบบไฟล์: JPG, JPEG, PNG
                          </p>
                          <p
                            style="
                              margin: 0px 15px;
                              font-size: small;
                              color: #adb5bd;
                            "
                          >
                            ขนาดไฟล์: ไม่เกิน 10 MB
                          </p>
                          <p
                            style="
                              margin: 0px 15px;
                              font-size: small;
                              color: #adb5bd;
                            "
                          >
                            ขนาดภาพแนะนำ: 850 × 850 pixels
                          </p>
                        </v-col>
                        <v-col cols="12" md="6">
                          <v-text-field
                            v-model="formUpdate.name"
                            label="ชื่อของรางวัลภาษาไทย"
                            outlined
                            dense
                            required
                            :rules="[rules.required]"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6">
                          <v-text-field
                            v-model="formUpdate.nameEng"
                            label="ชื่อของรางวัลภาษาอังกฤษ"
                            outlined
                            dense
                            required
                            :rules="[rules.required]"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6">
                          <v-textarea
                            v-model="formUpdate.description"
                            label="รายละเอียดภาษาไทย"
                            auto-grow
                            outlined
                            rows="3"
                            row-height="25"
                            :rules="[rules.required]"
                          ></v-textarea>
                        </v-col>
                        <v-col cols="12" md="6">
                          <v-textarea
                            v-model="formUpdate.descriptionEng"
                            label="รายละเอียดภาษาอังกฤษ"
                            auto-grow
                            outlined
                            rows="3"
                            row-height="25"
                            :rules="[rules.required]"
                          ></v-textarea>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="" md="6" lg="6" class="text-start">
                          <v-btn
                            :color="btnBack"
                            outlined
                            @click="onNextStep(1, 'edit')"
                          >
                            ย้อนกลับ
                          </v-btn>
                        </v-col>
                        <v-col cols="" md="6" lg="6" class="text-end">
                          <v-btn
                            dark
                            :color="btnContinue"
                            @click="onNextStep(3, 'edit')"
                          >
                            ต่อไป
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-stepper-content>

                  <v-stepper-content step="3">
                    <h3>เงื่อนไขการรับของรางวัล</h3>
                    <v-form ref="formPointStep3">
                      <v-card
                        v-if="formUpdate.supply === 'admin'"
                        v-for="setting in formUpdate.levelSettingsReward"
                        :key="setting.levelName"
                        class="mb-5 pl-10 pr-10"
                        style="
                          border: 1px solid gray;
                          border-radius: 8px;
                          min-height: 70px;
                        "
                      >
                        <div
                          class="d-flex align-center justify-space-between"
                          style="min-height: 70px"
                        >
                          <div class="d-flex align-center">
                            <v-switch
                              v-model="setting.enabled"
                              inset
                              :label="`${setting.levelName}`"
                              hide-details
                            />
                          </div>
                          <div class="d-flex align-center">
                            <v-text-field
                              v-model.number="setting.points"
                              label="คะแนนที่ใช้แลก *"
                              outlined
                              dense
                              hide-details
                              type="number"
                              style="max-width: 650px"
                              :rules="[
                                (v) =>
                                  v >= 0 || 'คะแนนต้องมากกว่าหรือเท่ากับ 0',
                              ]"
                            />
                          </div>
                        </div>
                      </v-card>
                    </v-form>

                    <div v-if="formUpdate.supply !== 'admin'">
                      <v-form ref="formStep3">
                        <v-row>
                          <v-col md="6">
                            <v-text-field
                              v-model="formUpdate.point"
                              label="คะแนนที่ใช้แลก"
                              outlined
                              dense
                              required
                              type="number"
                              :rules="[rules.required]"
                            ></v-text-field>
                          </v-col>
                          <v-col md="6">
                            <v-text-field
                              v-model="formUpdate.resale"
                              label="คะแนนช่วงโปรโมชั่น"
                              outlined
                              dense
                              required
                              type="number"
                            ></v-text-field>
                          </v-col>
                          <v-col md="6">
                            <v-select
                              v-model="formUpdate.levelId"
                              :items="dataLevel"
                              label="ระดับสมาชิกที่แลกได้"
                              dense
                              outlined
                              :rules="[rules.required]"
                            ></v-select>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col
                            cols="12"
                            class="pt-0 pb-0"
                            v-if="formUpdate.supply === 'รับหน้าร้าน'"
                          >
                            <v-checkbox
                              v-model="formUpdate.showReward"
                              :label="`ใช้คะแนนแลกของรางวัล`"
                            ></v-checkbox>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col
                            cols="12"
                            class="pt-0 pb-0"
                            v-if="formUpdate.supply === 'รับหน้าร้าน'"
                          >
                            <v-checkbox
                              v-model="checkboxLevelUpGiveReward"
                              :label="`แจกของรางวัลเมื่อสมาชิกเลื่อนระดับ`"
                            ></v-checkbox>
                          </v-col>
                        </v-row>
                        <v-row v-if="checkboxLevelUpGiveReward">
                          <v-col md="6" class="pt-0 pb-0">
                            <v-autocomplete
                              v-model="formUpdate.dataLevelUpgrade"
                              :items="
                                dataLevel.filter(
                                  (item) => item.value !== 'allLevel',
                                )
                              "
                              outlined
                              dense
                              small-chips
                              label="ระดับสมาชิก"
                              multiple
                            ></v-autocomplete>
                          </v-col>
                          <v-col md="6" class="pt-0 pb-0">
                            <v-text-field
                              v-model="formUpdate.amountToGive"
                              label="จำนวนที่ต้องการแจก"
                              outlined
                              dense
                              required
                              type="number"
                              suffix="ชิ้น"
                              :rules="
                                checkboxLevelUpGiveReward === true
                                  ? [rules.required]
                                  : ''
                              "
                            ></v-text-field>
                          </v-col>
                        </v-row>
                      </v-form>
                    </div>

                    <v-row>
                      <v-col cols="" md="6" lg="6" class="text-start">
                        <v-btn
                          :color="btnBack"
                          outlined
                          @click="onNextStep(2, 'edit')"
                        >
                          ย้อนกลับ
                        </v-btn>
                      </v-col>
                      <v-col cols="" md="6" lg="6" class="text-end">
                        <v-btn
                          dark
                          :color="btnContinue"
                           :loading='loading'
                          @click="onSubmit('edit')"
                        >
                          บันทึก
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-stepper-content>
                </v-stepper-items>
              </v-stepper>
            </v-card-text>
          </v-card>
        </v-dialog>

        <!-- delete -->
        <v-dialog v-model="dialogDelete" persistent max-width="40%">
          <v-card>
            <v-card-title class="pa-3">
              <span>ลบข้อมูลนี้</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      label="รหัส Reward*"
                      v-model="formUpdate.rewardId"
                      readonly
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                elevation="2"
                class="btn-color"
                style="color: white !important"
                x-large
                @click="dialogDelete = false"
              >
                <v-icon left> mdi-cancel</v-icon>
                ปิด
              </v-btn>
              <v-btn
                elevation="2"
                style="color: white !important"
                color="red darken-1"
                x-large
                @click="deleteData()"
              >
                <v-icon left>mdi-checkbox-marked-circle</v-icon>
                ลบ
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog
          v-model="dialogImport"
          persistent
          :max-width="resCol === '12' ? '' : '40%'"
          :fullscreen="resCol === '12' ? true : false"
        >
          <v-card>
            <v-form ref="form" v-model="validImport" lazy-validation>
              <v-card-text>
                <v-container>
                  <v-row style="padding-top: 15px; padding-bottom: 15px">
                    <v-col style="padding: 15px 16px 0px">
                      <h3>สร้างจำนวนของรางวัล</h3>
                    </v-col>
                    <v-col class="text-right">
                      <v-btn
                        small
                        fab
                        color="#E0E0E0"
                        @click="(dialogImport = false), clearCreateCode()"
                      >
                        <v-icon color="#173053">mdi-close</v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-row justify="center">
                    <v-col cols="12" class="text-center">
                      <VuetifyMoney
                        v-model="formImport1.count"
                        label="จำนวน"
                        outlined
                        dense
                        required
                        :rules="[rules.counter]"
                        v-bind:options="options2"
                      />
                      <v-radio-group v-model="formImport1.expireType" row>
                        <v-radio
                          label="กำหนดวันหมดอายุ"
                          value="FixDate"
                          color="#6683d3"
                        ></v-radio>
                        <v-radio
                          label="หมดอายุหลังจากวันที่แลกของรางวัล"
                          value="Redeem"
                          color="#6683d3"
                        ></v-radio>
                      </v-radio-group>
                      <VuetifyMoney
                        v-if="formImport1.expireType == 'Redeem'"
                        v-model="formImport1.countExpire"
                        label="จำนวนวัน"
                        outlined
                        dense
                        required
                        :rules="[rules.counter]"
                        v-bind:options="options2"
                      />
                      <v-row
                        v-if="formImport1.expireType == 'FixDate'"
                        style="padding: 0px 16px"
                      >
                        <v-col cols="6" style="padding: 12px 0px 0px">
                          <v-menu
                            v-model="menu3"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                v-model="formImport1.startDate"
                                label="วันที่เริ่มใช้งาน"
                                @blur="
                                  formImport1.startDate =
                                    parseDate(dateFormatted)
                                "
                                outlined
                                dense
                                v-bind="attrs"
                                v-on="on"
                                :rules="[rules.required]"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="formImport1.startDate"
                              @input="menu3 = false"
                            >
                              <v-spacer></v-spacer>
                              <v-btn
                                dense
                                color="primary"
                                @click="
                                  (formImport1.startDate = new Date()
                                    .toISOString()
                                    .substr(0, 10)),
                                    (menu1 = false)
                                "
                              >
                                วันที่ปัจจุบัน
                              </v-btn>
                            </v-date-picker>
                          </v-menu>
                        </v-col>
                        <v-col cols="6" style="padding: 12px 0px 0px">
                          <v-menu
                            v-model="menu4"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                v-model="formImport1.endDate"
                                label="วันหมดอายุ"
                                outlined
                                dense
                                v-bind="attrs"
                                v-on="on"
                                :rules="[rules.required]"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              :min="new Date().toISOString().substr(0, 10)"
                              v-model="formImport1.endDate"
                              @input="menu4 = false"
                            >
                            </v-date-picker>
                          </v-menu>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-btn
                  elevation="2"
                  color="#173053"
                  :loading="loading"
                  block
                  large
                  style="color: white !important"
                  :disabled="!validImport"
                  @click="createCode()"
                >
                  สร้าง Code
                </v-btn>
              </v-card-actions>
            </v-form>
          </v-card>
        </v-dialog>

        <v-dialog
          v-model="dialogUpdateQuata"
          persistent
          :max-width="resCol === '12' ? '' : '40%'"
          :fullscreen="resCol === '12' ? true : false"
        >
          <v-card>
            <v-form
              ref="form_UpdateQuata"
              v-model="validUpdateQuata"
              lazy-validation
            >
              <v-card-text>
                <v-container>
                  <v-row style="padding-top: 15px; padding-bottom: 15px">
                    <v-col style="padding: 15px 16px 0px">
                      <h3>เพิ่มจำนวนของรางวัล</h3>
                    </v-col>
                    <v-col class="text-right">
                      <v-btn
                        small
                        fab
                        color="#E0E0E0"
                        @click="(dialogUpdateQuata = false), clearDataAddcode()"
                      >
                        <v-icon color="#173053">mdi-close</v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-row justify="center">
                    <v-col cols="12" class="text-center">
                      <v-text-field
                        v-model="formUpdateQuata.count"
                        label="จำนวน"
                        outlined
                        dense
                        required
                        :rules="[rules.required]"
                      ></v-text-field>
                      <v-radio-group v-model="formUpdateQuata.expireType" row>
                        <v-radio
                          label="กำหนดวันหมดอายุ"
                          value="FixDate"
                          color="#6683d3"
                          disabled
                        ></v-radio>
                        <v-radio
                          label="หมดอายุหลังจากวันที่แลกของรางวัล"
                          value="Redeem"
                          color="#6683d3"
                          disabled
                        ></v-radio>
                      </v-radio-group>
                      <div v-if="formUpdateQuata.expireType == 'FixDate'">
                        <v-menu
                          v-model="menu"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          transition="scale-transition"
                          offset-y
                          min-width="290px"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="formUpdateQuata.startDate"
                              label="วันที่เริ่ม"
                              @blur="
                                formUpdateQuata.startDate =
                                  parseDate(dateFormatted)
                              "
                              outlined
                              dense
                              v-bind="attrs"
                              v-on="on"
                              disabled
                              :rules="[rules.required]"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="formUpdateQuata.startDate"
                            @input="menu = false"
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              dense
                              color="primary"
                              @click="
                                (formUpdateQuata.startDate = new Date()
                                  .toISOString()
                                  .substr(0, 10)),
                                  (menu = false)
                              "
                            >
                              ตกลง
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
                        <v-menu
                          v-model="menu1"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          transition="scale-transition"
                          offset-y
                          min-width="290px"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="formUpdateQuata.endDate"
                              label="วันที่หมดอายุ"
                              @blur="
                                formUpdateQuata.endDate =
                                  parseDate(dateFormatted)
                              "
                              outlined
                              dense
                              v-bind="attrs"
                              v-on="on"
                              disabled
                              :rules="[rules.required]"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="formUpdateQuata.endDate"
                            @input="menu1 = false"
                          >
                            <v-spacer></v-spacer>
                          </v-date-picker>
                        </v-menu>
                      </div>
                      <v-text-field
                        v-if="formUpdateQuata.expireType == 'Redeem'"
                        v-model="formUpdateQuata.countExpire"
                        label="จำนวนวัน"
                        outlined
                        dense
                        required
                        disabled
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-btn
                  elevation="2"
                  color="#173053"
                  :loading="loading"
                  block
                  dark
                  large
                  @click="addCode()"
                >
                  เพิ่มจำนวน
                </v-btn>
              </v-card-actions>
            </v-form>
          </v-card>
        </v-dialog>

        <v-dialog
          v-model="dialogUpdateDate"
          persistent
          :max-width="resCol === '12' ? '' : '40%'"
          :fullscreen="resCol === '12' ? true : false"
        >
          <v-card>
            <v-form
              ref="form_UpdateQuata"
              v-model="validUpdateQuata"
              lazy-validation
            >
              <v-card-text>
                <v-container>
                  <v-row justify="center">
                    <v-col cols="12" class="text-center">
                      <v-radio-group v-model="formUpdateQuata.expireType" row>
                        <v-radio
                          label="กำหนดวันหมดอายุ"
                          value="FixDate"
                          color="#6683d3"
                        ></v-radio>
                        <v-radio
                          label="หมดอายุหลังจากวันที่แลกของรางวัล"
                          value="Redeem"
                          color="#6683d3"
                        ></v-radio>
                      </v-radio-group>
                      <div v-if="formUpdateQuata.expireType == 'FixDate'">
                        <v-menu
                          v-model="menu"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          transition="scale-transition"
                          offset-y
                          min-width="290px"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="formUpdateQuata.startDate"
                              label="วันที่เริ่ม"
                              @blur="
                                formUpdateQuata.startDate =
                                  parseDate(dateFormatted)
                              "
                              outlined
                              dense
                              v-bind="attrs"
                              v-on="on"
                              disabled
                              :rules="[rules.required]"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="formUpdateQuata.startDate"
                            @input="menu = false"
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              dense
                              color="primary"
                              @click="
                                (formUpdateQuata.startDate = new Date()
                                  .toISOString()
                                  .substr(0, 10)),
                                  (menu = false)
                              "
                            >
                              ตกลง
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
                        <v-menu
                          v-model="menu1"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          transition="scale-transition"
                          offset-y
                          min-width="290px"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="formUpdateQuata.endDate"
                              label="วันที่หมดอายุ"
                              @blur="
                                formUpdateQuata.endDate =
                                  parseDate(dateFormatted)
                              "
                              outlined
                              dense
                              v-bind="attrs"
                              v-on="on"
                              disabled
                              :rules="[rules.required]"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="formUpdateQuata.endDate"
                            @input="menu1 = false"
                          >
                            <v-spacer></v-spacer>
                          </v-date-picker>
                        </v-menu>
                      </div>
                      <v-text-field
                        v-if="formUpdateQuata.expireType == 'Redeem'"
                        v-model="formUpdateQuata.countExpire"
                        label="จำนวนวัน"
                        outlined
                        dense
                        required
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-btn
                  elevation="2"
                  color="#173053"
                  :loading="loading"
                  block
                  dark
                  large
                  @click="addCode()"
                >
                  เพิ่มจำนวน
                </v-btn>
              </v-card-actions>
            </v-form>
          </v-card>
        </v-dialog>

        <v-dialog
          v-model="dialogUpdateQuata"
          persistent
          :max-width="resCol === '12' ? '' : '40%'"
          :fullscreen="resCol === '12' ? true : false"
        >
          <v-card>
            <v-form
              ref="form_UpdateQuata"
              v-model="validUpdateQuata"
              lazy-validation
            >
              <v-card-text>
                <v-container>
                  <v-row style="padding-top: 15px; padding-bottom: 15px">
                    <v-col style="padding: 15px 16px 0px">
                      <h3>เพิ่มจำนวนของรางวัล</h3>
                    </v-col>
                    <v-col class="text-right">
                      <v-btn
                        small
                        fab
                        color="#E0E0E0"
                        @click="(dialogUpdateQuata = false), clearDataAddcode()"
                      >
                        <v-icon color="#173053">mdi-close</v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-row justify="center">
                    <v-col cols="12" class="text-center">
                      <v-text-field
                        v-model="formUpdateQuata.count"
                        label="จำนวน"
                        outlined
                        dense
                        required
                        :rules="[rules.required]"
                      ></v-text-field>
                      <v-radio-group v-model="formUpdateQuata.expireType" row>
                        <v-radio
                          label="กำหนดวันหมดอายุ"
                          value="FixDate"
                          color="#6683d3"
                          disabled
                        ></v-radio>
                        <v-radio
                          label="หมดอายุหลังจากวันที่แลกของรางวัล"
                          value="Redeem"
                          color="#6683d3"
                          disabled
                        ></v-radio>
                      </v-radio-group>
                      <div v-if="formUpdateQuata.expireType == 'FixDate'">
                        <v-menu
                          v-model="menu"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          transition="scale-transition"
                          offset-y
                          min-width="290px"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="formUpdateQuata.startDate"
                              label="วันที่เริ่ม"
                              @blur="
                                formUpdateQuata.startDate =
                                  parseDate(dateFormatted)
                              "
                              outlined
                              dense
                              v-bind="attrs"
                              v-on="on"
                              disabled
                              :rules="[rules.required]"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="formUpdateQuata.startDate"
                            @input="menu = false"
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              dense
                              color="primary"
                              @click="
                                (formUpdateQuata.startDate = new Date()
                                  .toISOString()
                                  .substr(0, 10)),
                                  (menu = false)
                              "
                            >
                              ตกลง
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
                        <v-menu
                          v-model="menu1"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          transition="scale-transition"
                          offset-y
                          min-width="290px"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="formUpdateQuata.endDate"
                              label="วันที่หมดอายุ"
                              @blur="
                                formUpdateQuata.endDate =
                                  parseDate(dateFormatted)
                              "
                              outlined
                              dense
                              v-bind="attrs"
                              v-on="on"
                              disabled
                              :rules="[rules.required]"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="formUpdateQuata.endDate"
                            @input="menu1 = false"
                          >
                            <v-spacer></v-spacer>
                          </v-date-picker>
                        </v-menu>
                      </div>
                      <v-text-field
                        v-if="formUpdateQuata.expireType == 'Redeem'"
                        v-model="formUpdateQuata.countExpire"
                        label="จำนวนวัน"
                        outlined
                        dense
                        required
                        disabled
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-btn
                  elevation="2"
                  color="#173053"
                  :loading="loading"
                  block
                  dark
                  large
                  @click="addCode()"
                >
                  เพิ่มจำนวน
                </v-btn>
              </v-card-actions>
            </v-form>
          </v-card>
        </v-dialog>

        <v-dialog
          v-model="dialogChangeExpireDate"
          :max-width="resCol === '12' ? '' : '40%'"
          :fullscreen="resCol === '12' ? true : false"
        >
          <v-card>
            <v-form
              ref="form_UpdateQuata"
              v-model="validUpdateQuata"
              lazy-validation
            >
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col
                      cols="6"
                      class="text-left"
                      style="display: flex; align-items: center"
                    >
                      <h4>เปลี่ยนวันหมดอายุ</h4>
                    </v-col>
                    <v-col cols="6" class="text-right">
                      <v-btn
                        small
                        fab
                        color="#E0E0E0"
                        @click="
                          (dialogChangeExpireDate = false),
                            clearDataChangeExpire()
                        "
                      >
                        <v-icon color="#173053">mdi-close</v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-row justify="center">
                    <v-col cols="12" class="text-center">
                      <v-radio-group v-model="formUpdateQuata.expireType" row>
                        <v-radio
                          label="กำหนดวันหมดอายุ"
                          value="FixDate"
                          color="#6683d3"
                        ></v-radio>
                        <v-radio
                          label="หมดอายุหลังจากวันที่แลกของรางวัล"
                          value="Redeem"
                          color="#6683d3"
                        ></v-radio>
                      </v-radio-group>
                      <div v-if="formUpdateQuata.expireType == 'FixDate'">
                        <v-menu
                          v-model="menu5"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          transition="scale-transition"
                          offset-y
                          min-width="290px"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="formUpdateQuata.startDate"
                              label="วันที่เริ่ม"
                              outlined
                              dense
                              v-bind="attrs"
                              v-on="on"
                              :rules="[rules.required]"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="formUpdateQuata.startDate"
                            @input="menu5 = false"
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              dense
                              color="primary"
                              @click="
                                (formUpdateQuata.startDate = new Date()
                                  .toISOString()
                                  .substr(0, 10)),
                                  (menu5 = false)
                              "
                            >
                              ตกลง
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
                        <v-menu
                          v-model="menu6"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          transition="scale-transition"
                          offset-y
                          min-width="290px"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="formUpdateQuata.endDate"
                              label="วันที่หมดอายุ"
                              outlined
                              dense
                              v-bind="attrs"
                              v-on="on"
                              :rules="[rules.required]"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="formUpdateQuata.endDate"
                            @input="menu6 = false"
                          >
                            <v-spacer></v-spacer>
                          </v-date-picker>
                        </v-menu>
                      </div>
                      <v-text-field
                        v-if="formUpdateQuata.expireType == 'Redeem'"
                        v-model="formUpdateQuata.countExpire"
                        label="จำนวนวัน"
                        outlined
                        dense
                        required
                        type="number"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-btn
                  elevation="2"
                  style="color: white !important"
                  color="#173053"
                  :loading="loading"
                  block
                  large
                  :disabled="checkChangeExpire()"
                  @click="changeExpire()"
                >
                  เปลี่ยวันหมดอายุ
                </v-btn>
              </v-card-actions>
            </v-form>
          </v-card>
        </v-dialog>

        <v-dialog
          v-model="dialogView"
          persistent
          :max-width="resCol === '12' ? '' : '40%'"
          :fullscreen="resCol === '12' ? true : false"
        >
          <v-card>
            <v-card-title class="pa-3">
              <span>จำนวนของรางวัล</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row justify="center">
                  <v-col cols="12" class="text-center">
                    <v-data-table
                      :headers="columnsView"
                      :items="dataItemView"
                      :items-per-page="10"
                    >
                      <template v-slot:[`item.startDate`]="{ item }">
                        {{ thaiFormattedDate(item.startDate) }}
                      </template>
                      <template v-slot:[`item.endDate`]="{ item }">
                        {{ thaiFormattedDate(item.endDate) }}
                      </template>
                    </v-data-table>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                elevation="2"
                style="color: white !important"
                class="btn-color"
                @click="dialogView = false"
              >
                <!-- <v-icon left> mdi-cancel</v-icon> -->
                ปิด
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogImportExcel" persistent max-width="40%">
          <v-card>
            <v-card-title class="pa-3">
              <span>เพิ่มจำนวนของรางวัล</span>
            </v-card-title>
            <v-form
              ref="form_importExcel"
              v-model="validImportExcel"
              lazy-validation
            >
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12">
                      <input
                        type="file"
                        @change="importData"
                        accept=".xls,.xlsx"
                      />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <v-btn dark color="#1b437c" @click="exportToExcel">
                        <!-- <download-excel
                          :data="export_datas2"
                          :fields="export_fields2"
                          :type="exportType"
                          :worksheet="exportWorksheet"
                          :name="exportFileName2"
                        > -->
                        Donwload template
                        <!-- </download-excel> -->
                      </v-btn>
                      <br />
                      <p style="color: red mt-3">
                        *หมายเหตุ : กรณีมีรหัสมากกว่า 1 รหัสให้คั้นด้วย "/"
                      </p>
                      <p style="color: red">ตัวอย่าง ABcd/123456</p>
                    </v-col>
                  </v-row>
                  <v-row>
                    <!-- <v-col cols="6">
                      <v-autocomplete
                        v-model="formImport1.expireType"
                        :items="typeExpire"
                        label="ประเภทวันหมดอายุ"
                        dense
                        required
                        :rules="[rules.required]"
                        outlined
                        @change="resetType()"
                      ></v-autocomplete>
                    </v-col> -->
                    <!-- <v-col
                      cols="6"
                      v-if="
                        formImport1.expireType == 'Redeem' &&
                        formUpdate.supply != 'link_code'
                      "
                    >
                      <VuetifyMoney
                        v-model="formImport1.countExpire"
                        label="จำนวนวัน"
                        outlined
                        dense
                        required
                        :rules="[rules.required]"
                        v-bind:options="options2"
                      />
                    </v-col> -->
                  </v-row>
                  <v-row v-if="formImport1.expireType == 'FixDate'">
                    <v-col cols="6">
                      <v-menu
                        v-model="menu1"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="formImport1.startDate"
                            prepend-icon="mdi-calendar"
                            label="วันที่เริ่มใช้งาน"
                            outlined
                            dense
                            v-bind="attrs"
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="formImport1.startDate"
                          @input="menu1 = false"
                        >
                          <v-spacer></v-spacer>
                          <!-- <v-btn
                            dense
                            color="primary"
                            @click="
                              (formImport1.startDate = new Date()
                                .toISOString()
                                .substr(0, 10)),
                                (formImport1.endDate = formImport1.startDate),
                                (menu1 = false)
                            "
                          >
                            วันที่ปัจจุบัน
                          </v-btn> -->
                        </v-date-picker>
                      </v-menu>
                    </v-col>
                    <v-col cols="6">
                      <v-menu
                        v-model="menu2"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="formImport1.endDate"
                            prepend-icon="mdi-calendar"
                            label="วันหมดอายุ"
                            outlined
                            dense
                            v-bind="attrs"
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="formImport1.endDate"
                          @input="menu2 = false"
                        >
                        </v-date-picker>
                      </v-menu>
                    </v-col>
                  </v-row>
                  <!-- <v-row v-if="formImport1.expireType == 'Redeem'">
                    <v-text-field
                        v-if="formImport1.expireType == 'Redeem'"
                        v-model="formImport1.countExpire"
                        label="จำนวนวัน"
                        outlined
                        dense
                        required
                        type="number"
                      ></v-text-field>
                  </v-row> -->
                </v-container>
              </v-card-text>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12">
                      <template>
                        <v-data-table
                          :headers="columnsImport"
                          :items="dataItemImport"
                          :items-per-page="5"
                          :sort-by="['status']"
                          :sort-desc="[true]"
                        >
                          <template v-slot:[`item.status`]="{ item }">
                            <v-chip
                              color="red"
                              outlined
                              v-if="item.status === 'False'"
                              >False</v-chip
                            >
                            <v-chip
                              color="green"
                              outlined
                              v-if="item.status === 'True'"
                              >True</v-chip
                            >
                          </template>
                        </v-data-table>
                      </template>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  elevation="2"
                  dark
                  color="#173053"
                  style="color: white !important"
                  @click="
                    (dialogImportExcel = false),
                      (dataItemImport = []),
                      clearCreateCode()
                  "
                >
                  ปิด
                </v-btn>
                <template v-if="!dataItemImportChecKHide">
                  <v-btn
                    elevation="2"
                    color="green"
                    style="color: white !important"
                    :disabled="
                      !validImportExcel ||
                      formImport1.endDate === '' ||
                      formImport1.startDate === '' ||
                      dataItemImport.some(item => item.status === 'False')
                    "
                    :loading="loading1"
                    @click="importDataApprove('add')"
                  >
                    นำเข้าใหม่ทั้งหมด
                  </v-btn>
                </template>
              </v-card-actions>
            </v-form>
          </v-card>
        </v-dialog>

        <!-- data table -->
        <v-col cols="12">
          <v-card elevation="5" v-if="dataReady">
            <v-card-title>
              <v-text-field
                v-model="searchAll2"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
            </v-card-title>
            <v-card-text>
              <v-data-table
                :headers="columns"
                :items="dataItem"
                :search="searchAll2"
                :items-per-page="10"
              >
                <!-- <template v-slot:[`item.point`]="{item}">
                  <v-chip>a</v-chip>

                </template> -->
                <template v-slot:[`item.pictureUrl`]="{ item }">
                  <v-avatar color="primary" size="40">
                    <img :src="item.pictureUrl" alt="img"
                  /></v-avatar>
                </template>
                <template v-slot:[`item.name`]="{ item }">
                  <div
                    v-if="
                      new Date().getTime() > new Date(item.endDate).getTime() &&
                      item.expireTypeReward === 'FixDate'
                    "
                  >
                    {{ item.name }}
                    <p style="font-weight: 100" class="mb-0 expire-reward">
                      ของรางวัลหมดอายุ
                    </p>
                  </div>
                  <div v-else>
                    {{ item.name }}
                  </div>
                </template>
                <template v-slot:[`item.CREATE_DATE`]="{ item }">
                  {{ thaiFormattedDate(item.CREATE_DATE) }}
                </template>
                <template v-slot:[`item.point`]="{ item }">
                  <div v-if="item.supply === 'admin'">
                    <div
                      v-for="(i,index) in JSON.parse(item.levelSettingsReward)"
                      :key="index"
                    >
                      <v-chip class="mt-1 mb-1"
                        >{{ formatNumber(i.points) }} คะแนน
                      </v-chip>
                    </div>
                  </div>
                  <div v-else>
                    <v-chip class="mt-1 mb-1"
                      >{{ formatNumber(item.point) }} คะแนน</v-chip
                    >
                  </div>
                </template>

                <template v-slot:[`item.levelNm`]="{ item }">
                  <div v-if="item.supply === 'admin'">
                    <div
                      v-for="(i, index) in JSON.parse(item.levelSettingsReward)"
                      :key="index"
                    >
                      <v-chip class="mt-1 mb-1">{{
                        formatNumber(i.levelName)
                      }}</v-chip>
                    </div>
                  </div>
                  <div v-else>
                    <v-chip class="mt-1 mb-1">{{
                      item.levelNm
                    }}</v-chip>
                  </div>
                </template>
                <template v-slot:[`item.supply`]="{ item }">
                  <v-chip>
                    <v-icon>{{
                      item.supply === "รับหน้าร้าน"
                        ? "mdi-store"
                        : item.supply === "link_code"
                        ? "mdi-barcode-scan"
                        : item.supply === "จัดส่ง"
                        ? "mdi-truck-delivery-outline"
                        : item.supply === "admin"
                        ? "mdi-account-box"
                        : "mdi-coupon"
                    }}</v-icon>
                    <p class="mb-0 mr-1"></p>
                    {{ item.supply }}
                  </v-chip>
                </template>
                <template v-slot:[`item.expireTypeReward`]="{ item }">
                  {{
                    item.expireTypeReward === null
                      ? "ไม่มีข้อมูล"
                      : item.expireTypeReward === "FixDate"
                      ? "กำหนดวันหมดอายุ"
                      : "หมดอายุหลังจากแลกรางวัล"
                  }}
                </template>
                <template v-slot:[`item.endDate`]="{ item }">
                  <div>
                    {{
                      item.expireTypeReward === null
                        ? "ไม่มีข้อมูล"
                        : item.expireTypeReward === "FixDate"
                        ? thaiFormattedDate(item.endDate)
                        : item.countExpire + " วัน"
                    }}<br />
                    <v-btn
                      v-if="
                        new Date().getTime() >
                          new Date(item.endDate).getTime() &&
                        item.expireTypeReward === 'FixDate'
                      "
                      style="color: white !important"
                      color="#1B437C"
                      dark
                      x-small
                      @click="(dialogChangeExpire = true), (dataReward = item)"
                      >เปลี่ยนวันหมดอายุ</v-btn
                    >
                  </div>
                </template>
                <template v-slot:[`item.action`]="{ item }">
                  <v-menu
                    bottom
                    min-width="200px"
                    offset-y
                    transition="slide-y-transition"
                  >
                    <template v-slot:activator="{ on }">
                      <v-btn
                        style="
                          background-color: #e0f4ff;
                          border-radius: 10px;
                          font-weight: bold;
                        "
                        class="black--text pa-5"
                        elevation="0"
                        v-on="on"
                      >
                        เลือก
                        <v-icon color="#73777B" class="ml-2">
                          mdi-chevron-down
                        </v-icon>
                      </v-btn>
                    </template>
                    <v-card>
                      <v-list flat>
                        <v-list-item-group
                          v-model="selectedItem"
                          color="primary"
                        >
                          <v-list-item
                            @click.stop="getDataById(item, 'redeem')"
                            v-if="item.supply === 'admin' && item.quotaCode > 0"
                          >
                            <v-list-item-title
                              ><v-icon class="mr-2"> mdi-account-box </v-icon
                              >แลกของรางวัลเฉพาะลูกค้า</v-list-item-title
                            >
                          </v-list-item>

                          <v-list-item @click.stop="getDataById(item, 'edit')">
                            <v-list-item-title
                              ><v-icon class="mr-2"> mdi-tools </v-icon
                              >แก้ไขข้อมูล</v-list-item-title
                            >
                          </v-list-item>

                          <v-list-item
                            v-show="
                              item.supply != 'link_code' &&
                              item.statusAdd == 'True'
                            "
                            @click.stop="
                              (dialogImport = true),
                                getDataById(item, 'Import'),
                                validate()
                            "
                          >
                            <v-list-item-title
                              ><v-icon class="mr-2">
                                mdi-database-import-outline </v-icon
                              >สร้างจำนวนของรางวัล</v-list-item-title
                            >
                          </v-list-item>
                          <v-list-item
                            v-if="item.quotaCode > 0"
                            @click.stop="
                              (dialogView = true), getDataImport(item)
                            "
                          >
                            <v-list-item-title
                              ><v-icon class="mr-2">mdi-eye-circle</v-icon
                              >จำนวนของรางวัล</v-list-item-title
                            >
                          </v-list-item>
                          <v-list-item
                            v-show="
                              item.supply != 'link_code' &&
                              item.statusAdd == 'False'
                            "
                            @click.stop="
                              getDataItem(item, 'add'), validate('Import')
                            "
                          >
                            <v-list-item-title
                              ><v-icon class="mr-2"> mdi-database-plus </v-icon
                              >เพิ่มจำนวนของรางวัล</v-list-item-title
                            >
                          </v-list-item>
                          <v-list-item
                            v-show="
                              item.supply != 'coupon' &&
                              item.statusAdd != 'True'
                            "
                            @click.stop="getDataItem(item, 'change')"
                          >
                            <v-list-item-title
                              ><v-icon class="mr-2"> mdi-calendar-clock </v-icon
                              >เปลี่ยนวันหมดอายุ</v-list-item-title
                            >
                          </v-list-item>
                          <v-list-item
                            v-if="item.supply == 'link_code'"
                            @click.stop="
                              (dialogImportExcel = true),
                                getDataById(item),
                                validate('ImportExcel')
                            "
                          >
                            <v-list-item-title>
                              <v-icon class="mr-2"> mdi-microsoft-excel </v-icon
                              >import excel เพิ่มของรางวัล</v-list-item-title
                            >
                          </v-list-item>
                          <v-list-item
                            @click.stop="getDataById(item, 'delete')"
                          >
                            <v-list-item-content>
                              <v-list-item-title
                                ><v-icon class="mr-2"> mdi-delete </v-icon
                                >ลบข้อมูล</v-list-item-title
                              >
                            </v-list-item-content>
                          </v-list-item>
                        </v-list-item-group>
                      </v-list>
                    </v-card>
                  </v-menu>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
          <div v-if="!dataReady" class="text-center">
            <v-progress-circular
              indeterminate
              color="primary"
            ></v-progress-circular>
          </div>
        </v-col>

        <!-- dailog status -->
        <v-dialog v-model="dialogStatus" max-width="40%">
          <v-card>
            <v-container>
              <v-card-title class="text-h5 grey lighten-2">
                บันทึกสำเร็จ
              </v-card-title>
              <br />
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" class="text-center">
                    <v-alert dense outlined type="success"
                      >เพิ่มข้อมูลสำเร็จ : {{ formStatus.sucess }}</v-alert
                    >
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-col cols="12" class="text-center">
                    <v-alert dense outlined type="error"
                      >เพิ่มข้อมูลไม่สำเร็จ : {{ formStatus.fail }}</v-alert
                    >
                  </v-col>
                </v-row></v-card-text
              >
              <v-card-actions>
                <v-btn block color="primary" @click="dialogStatus = false">
                  OK
                </v-btn>
              </v-card-actions>
            </v-container>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogRedeemForAdmin" persistent max-width="800px">
          <v-card class="pa-5">
            <v-card-title>
              <span class="text-h5 pb-3">แลกของรางวัลเฉพาะลูกค้าที่กำหนด</span>
              <v-spacer></v-spacer>
              <v-btn
                icon
                @click="(dialogRedeemForAdmin = false), clearFormRedeem()"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col cols="12" xs="12" sm="12" md="6" xl="6" lg="6">
                  <v-card class="pa-5" rounded height="500">
                    <v-row>
                      <v-col cols="12" md="12">
                        <h4>ข้อมูลของรางวัล</h4>
                        <!-- {{ formUpdate.levelSettingsReward }} -->
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" md="12">
                        <div class="d-flex justify-center">
                          <v-img
                            height="220"
                            width="220"
                            :src="formUpdate.pictureUrl"
                          ></v-img>
                        </div>
                      </v-col>
                    </v-row>
                    <v-row class="pb-0">
                      <v-col cols="12" md="12" class="pt-0 pb-0">
                        <p
                          class="mb-0"
                          style="color: #2e263d; font-size: medium"
                        >
                          {{ formUpdate.name }}
                        </p>
                      </v-col>
                    </v-row>
                    <v-row class="pb-0">
                      <v-col cols="12" md="12">
                        <p class="mb-0">{{ "รายละเอียดของรางวัล" }}</p>
                        <p class="mb-0" style="color: #2e263d">
                          {{ formUpdate.description }}
                        </p>
                      </v-col>
                    </v-row>
                    <v-row class="pb-0">
                      <v-col cols="12" md="6" class="pt-0">
                        <p>{{ "คะแนนใช้แลกของรางวัล" }}</p>
                      </v-col>
                      <v-col cols="12" md="6" class="text-right pt-0">
                        <p
                          :style="
                            'color: ' +
                            (pointInLevel > dataMember.currentPoint
                              ? ' #FF4C51'
                              : pointInLevel < dataMember.currentPoint
                              ? '#4DB600'
                              : '#2E263D')
                          "
                        >
                          {{ pointInLevel ? pointInLevel : 0 }}
                        </p>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" md="6">
                        <p>ระดับสมาชิกที่มีสิทธิ์</p>
                      </v-col>
                      <v-col cols="12" md="6" class="text-end">
                        {{ levelActive }}
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="6" xl="6" lg="6">
                  <v-card class="pa-5" rounded height="500">
                    <v-row>
                      <v-col cols="12" md="12">
                        <h4>เลือกลูกค้า</h4>
                        <!-- {{ dataMember }} -->
                      </v-col>
                    </v-row>
                    <v-row class="pb-0">
                      <v-col cols="12" md="12">
                        <v-text-field
                          v-model="checkMember"
                          label="กรอกเบอร์โทรศัพท์ลูกค้า"
                          outlined
                          hide-details
                          @input="onCheckMember()"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row class="pt-0">
                      <v-col cols="12" md="12" class="text-center">
                        <v-avatar color="primary" size="100">
                          <img
                            :src="
                              dataMember.picture
                                ? dataMember.picture
                                : 'https://cdn-icons-png.flaticon.com/512/3135/3135715.png'
                            "
                          />
                        </v-avatar>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" md="12" class="text-center">
                        <p class="mb-0">
                          {{ dataMember.name ? dataMember.name : "-" }}
                        </p>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" md="6" class="pb-0">
                        <p class="mb-0">ชื่อ - นามสกุล</p>
                      </v-col>
                      <v-col cols="12" md="6" class="text-right pb-0">
                        <p class="mb-0" style="font-style: 200">
                          {{
                            dataMember.nameCustomer
                              ? dataMember.nameCustomer
                              : "-"
                          }}
                        </p>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" md="6" class="pb-0">
                        <p class="mb-0">ระดับสมาชิก</p>
                      </v-col>
                      <v-col cols="12" md="6" class="text-right pb-0">
                        <p class="mb-0" style="font-style: 200">
                          {{
                            dataMember.LevelName ? dataMember.LevelName : "-"
                          }}
                        </p>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" md="6" class="pb-0">
                        <p class="mb-0">คะแนนคงเหลือ</p>
                      </v-col>
                      <v-col cols="12" md="6" class="text-right">
                        <p class="mb-0" style="font-style: 200">
                          {{
                            dataMember.currentPoint
                              ? dataMember.currentPoint
                              : "-"
                          }}
                        </p>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" md="12" class="pb-0 pt-0">
                        <p class="mb-0" style="color: #ff4c51">{{ msg }}</p>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions class="pr-0 pt-5">
              <v-spacer></v-spacer>
              <v-btn
                outlined
                @click="
                  (dialogRedeemForAdmin = false),
                    (dataMember = {}),
                    (checkMember = ''),
                    clearFormRedeem()
                "
              >
                ยกเลิก
              </v-btn>
              <v-btn
                class="text-white"
                style="background-color: #1c3051"
                :disabled="disRedeem"
                @click="redeemSubmit()"
                :loading="loadingAdd"
              >
                แลกของรางวัลให้ลูกค้า
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </v-main>
  </div>
</template>
<script>
import axios from 'axios' // api
import VuetifyMoney from '../VuetifyMoney.vue'
import adminLeftMenu from '../Sidebar.vue' // เมนู
import JsonExcel from 'vue-json-excel' // https://www.npmjs.com/package/vue-json-excel
import XLSX from 'xlsx' // import xlsx
import readXlsxFile from 'read-excel-file'
import moment from 'moment' // แปลง date
// import { string } from 'vue-xlsx-table'

export default {
  components: {
    'left-menu-admin': adminLeftMenu,
    VuetifyMoney,
    downloadExcel: JsonExcel,
    XLSX,
    readXlsxFile
  },
  created () {
    // setInterval(this.getNowGlobal, 1000)
  },
  computed: {
    resCol () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          return '12'
        case 'sm':
          return '12'
        case 'md':
          return '6'
        case 'lg':
          return '6'
        case 'xl':
          return '6'
      }
      console.log(
        'this.$vuetify.breakpoint.name',
        this.$vuetify.breakpoint.name
      )
    }
  },
  watch: {
    dialogChangeExpire (newQuestion, oldQuestion) {
      if (newQuestion) {
        // this.dataPackage = null
        this.pickerChangeExpire = new Date(
          Date.now() - new Date().getTimezoneOffset() * 60000
        )
          .toISOString()
          .substr(0, 10)
      }
    }
  },
  data () {
    return {
      levelActive: '-',
      msg: '',
      disRedeem: true,
      dataMember: {},
      checkMember: '',
      steped: 1,
      selectedItem: 1,
      switch1: true,
      rules: {
        required: (value) => !!value || 'กรุณากรอก.',
        requiredArray: (value) => value.length > 0 || 'กรุณากรอก.',
        counter: (value) =>
          (value.length <= 3 && parseInt(value) !== 0) || 'ไม่เกินหลักร้อย',
        requiredLevel: (v) => (v && v.length > 0) || 'กรุณากรอก',
        imageType: (v) => {
          if (!v) return true
          const validTypes = ['image/jpeg', 'image/jpg', 'image/png']
          return (
            validTypes.includes(v.type) || 'อนุญาตเฉพาะไฟล์ JPG, JPEG, PNG'
          )
        },
        fileSize: (v) => {
          if (!v) return true
          const maxSizeMB = 10
          return (
            v.size / 1024 / 1024 <= maxSizeMB ||
            `ขนาดไฟล์ต้องไม่เกิน ${maxSizeMB} MB`
          )
        }
      },
      selectType: [
        {
          text: 'รับหน้าร้าน',
          value: 'รับหน้าร้าน',
          icon: 'mdi-store'
        },
        {
          text: 'จัดส่ง',
          value: 'จัดส่ง',
          icon: 'mdi-truck-delivery'
        },
        {
          text: 'Link / Code',
          value: 'link_code',
          icon: 'mdi-barcode-scan'
        },
        {
          text: 'เฉพาะลูกค้าที่กำหนด',
          value: 'admin',
          icon: 'mdi-account-box'
        }
      ],
      filesAdd: null,
      filesUpdate: null,
      formAdd: {
        name: '',
        nameEng: '',
        subName: '',
        point: 0,
        quota: 0,
        description: '',
        descriptionEng: '',
        CREATE_USER: '',
        LAST_USER: '',
        pictureUrl: '',
        pictureUrlPreview: '',
        trending: 'False',
        most: 'False',
        specialOffer: 'False',
        dataLevelUpgrade: [],
        shopId: this.$session.getAll().data.shopId,
        levelNm: '',
        levelId: '',
        supply: '',
        statusAdd: 'True',
        showReward: true,
        resale: 0,
        masBranchId: '',
        levelSettingsReward: [],
        amountToGive: 0
      },
      settingsReward: [],
      resLevel: [],
      // btn
      btnContinue: '#1C3051',
      btnBack: '#8A8D93',
      // condition
      checkboxLevelUpGiveReward: false,
      items: [
        { text: 'แก้ไขข้อมูล', icon: 'mdi-clock' },
        { text: 'สร้างจำนวนของรางวัล', icon: 'mdi-account' },
        { text: 'จำนวนของรางวัล', icon: 'mdi-account' },
        { text: 'เพิ่มจำนวนของรางวัล', icon: 'mdi-account' },
        { text: 'import excel เพิ่มของรางวัล', icon: 'mdi-account' },
        { text: 'ลบข้อมูล', icon: 'mdi-flag' }
      ],
      PK: '',
      path: '/reward/', // Path Model
      returnLink: '/Master/Reward',
      // checkboxLevelUpGiveReward: false,
      statusRadioLevelUpgrade: false,
      options2: {
        locale: 'en-US',
        prefix: '',
        suffix: '',
        length: 9,
        precision: 0
      },
      // End Menu Config
      dataReady: true,
      pickerChangeExpire: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
      dddd: false,
      dataReadyView: true,
      boolenAlert: false,
      canvas: true,
      dateTime: '', // Generate DateTime
      date: new Date().toISOString().substr(0, 10),
      menu: false,
      menu1: false,
      menu2: false,
      menu3: false,
      menu4: false,
      menu5: false,
      menu6: false,
      dialogChangeExpire: false,
      dataReward: null,
      code: 'AGE_', // Generate Code
      // Dialog Config ADD EDIT DELETE IMPORT
      dialogAdd: false,
      dialogEdit: false,
      dialogDelete: false,
      dialogImport: false,
      dialogUpdateQuata: false,
      dialogChangeExpireDate: false,
      dialogUpdateDate: false,
      dialogStatus: false,
      dialogImportExcel: false,
      dialogView: false,
      dialogRedeemForAdmin: false,
      // END Dialog Config ADD EDIT DELETE
      session: this.$session.getAll(),
      // Search All
      searchAll: '',
      searchAll2: '',
      // filesAdd: null,
      // filesUpdate: null,
      // Search Advanced
      search: {
        masAgeCode: '',
        masAgeName: '',
        create_date_start: '',
        create_date_end: '',
        last_date_start: '',
        last_date_end: ''
      },
      formStatus: {
        fail: 0,
        sucess: 0,
        dataStatus: []
      },
      formImport1: {
        prefix: '',
        rewardCode: '',
        count: '',
        CREATE_USER: '',
        LAST_USER: '',
        shopId: this.$session.getAll().data.shopId,
        rewardId: '',
        startDate: '',
        endDate: '',
        expireType: 'FixDate',
        countExpire: 0,
        genType: '',
        redeemStatus: ''
      },
      formUpdateQuata: {
        prefix: '',
        rewardCode: '',
        count: '',
        CREATE_USER: '',
        LAST_USER: '',
        shopId: this.$session.getAll().data.shopId,
        rewardId: '',
        startDate: '',
        endDate: '',
        expireType: '',
        countExpire: '',
        genType: '',
        redeemStatus: ''
      },
      numbranch: [],
      formUpdate: {
        rewardId: '',
        name: '',
        subName: '',
        point: 0,
        quota: 0,
        description: '',
        LAST_USER: '',
        pictureUrl: '',
        pictureUrlPreview: '',
        trending: 'False',
        most: 'False',
        specialOffer: 'False',
        shopId: '',
        levelNm: '',
        levelId: 'allLevel',
        dataLevelUpgrade: [],
        statusAdd: '',
        showReward: null,
        resale: ''
      },
      dataItemImportChecKHide: true,
      // End Form Config ADD EDIT
      // Data Table Config
      typeExpire: [
        { text: 'กำหนดวันหมดอายุ', value: 'FixDate' },
        { text: 'หมดอายุหลังจากวันที่แลกของรางวัล', value: 'Redeem' }
      ],
      columnsStatus: [
        { text: 'Reward Code', value: 'rewardCode' },
        { text: 'Status', value: 'status', sortable: false }
      ],
      columnsView: [
        { text: 'Reward Code', value: 'rewardCode' },
        { text: 'Expire Type', value: 'expireType' },
        { text: 'สถานะ', value: 'redeemStatus' },
        { text: 'จำนวนวันหมดอายุ', value: 'countExpire' },
        { text: 'วันที่เริ่ม', value: 'startDate' },
        { text: 'วันที่สิ้นสุด', value: 'endDate' }
      ],
      columnsImport: [
        { text: 'Reward Code', value: 'rewardCode' },
        { text: 'Status', value: 'status', sortable: false }
      ],
      columns: [
        { text: 'รูป', value: 'pictureUrl' },
        { text: 'ชื่อ', value: 'name' },
        { text: 'ระดับ', value: 'levelNm' },
        { text: 'คะแนนที่ใช้แลก', value: 'point' },
        { text: 'จำนวนคงเหลือ', value: 'quotaCode' },

        { text: 'ประเภทจัดส่ง', value: 'supply' },
        { text: 'ประเภทวันหมดอายุ', value: 'expireTypeReward' },
        { text: 'วันหมดอายุ', value: 'endDate', width: 150 },
        { text: 'จัดการ', value: 'action', sortable: false, align: 'center' }
      ],
      datItemImport: [],
      dataItem: [],
      dataItemView: [],
      validAdd: true,
      validUpdate: true,
      validImport: true,
      validUpdateQuata: true,
      validImportExcel: true,
      exportFileName2: 'template.xlsx',
      dataLevel: [],
      panel: [0, 1, 2],
      exportType: 'xls',
      exportFileName: 'Template.xls',
      exportWorksheet: 'WorkSheet',
      export_fields: {
        rewardCode: 'rewardCode'
      },
      export_datas: [
        {
          rewardCode: 'กรอก Code'
        }
      ],
      loadingAdd: false,
      loadingEdit: false,
      loading: false,
      loading1: false,
      dataGetForAddReward: null,
      pointInLevel: 0
    }
  },
  beforeCreate () {
    if (!this.$session.exists()) {
      this.$router.push('/Core/Login')
    }
  },
  async mounted () {
    sessionStorage.clear('haveExpireReward')
    console.log(this.$session.getAll().data)
    this.dataReady = false
    if (this.session.data.shopId === 'U4e23f7bf31b362622ff7c5c06dfdf350') {
      this.formAdd.BvpExpieMinAfterUse = '15'
    }
    // Get Data
    await this.getDataLevel(
      this.DNS_IP,
      this.session.data.shopId,
      this.returnLink
    )
    await this.getDataReward()
  },
  methods: {
    exportToExcel () {
      const worksheet = XLSX.utils.json_to_sheet(this.export_datas)
      const workbook = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(workbook, worksheet, this.exportWorksheet)

      // สร้างไฟล์ .xlsx
      XLSX.writeFile(workbook, this.exportFileName2)
    },
    clearFormRedeem () {
      this.formUpdate.pictureUrl = ''
      this.formUpdate.name = ''
      this.formUpdate.description = ''
      this.formUpdate.point = ''
      this.levelActive = '-'
      this.checkMember = ''
      this.dataMember.picture = ''
      this.dataMember.name = ''
      this.dataMember.nameCustomer = ''
      this.dataMember.LevelName = ''
      this.dataMember.currentPoint = ''
      this.msg = ''
      this.pointInLevel = 0
      this.loadingAdd = false
    },
    redeemSubmit () {
      console.log('this.formUpdate.rewardId', this.formUpdate.rewardId)
      this.loadingAdd = true

      try {
        axios
          .get(
            this.DNS_IP +
              '/rewardCode/get?shopId=' +
              this.session.data.shopId +
              '&rewardId=' +
              this.formUpdate.rewardId
          )
          .then((res) => {
            console.log(res.status === 200)
            if (res.status === 200) {
              if (res.data[0].expireType === 'FixDate') {
                var inputDate = new Date(res.data[0].endDate).getTime()
                var todaysDate = new Date().getTime()
                if (todaysDate < inputDate) {
                  const params = {
                    redeemStatus: 'use',
                    rewardId: this.formUpdate.rewardId,
                    supply: 'admin',
                    points: this.pointInLevel,
                    img: this.formUpdate.pictureUrl
                  }
                  axios
                    .post(this.DNS_IP + '/rewardCode/edit', params, {
                      headers: {
                        shopId: this.session.data.shopId,
                        lineUserId: this.dataMember.lineUserId
                          ? this.dataMember.lineUserId
                          : null,
                        lineId: this.dataMember.liffUserId
                          ? this.dataMember.liffUserId
                          : null,
                        memberId: this.dataMember.memberId
                          ? this.dataMember.memberId
                          : null
                      }
                    })
                    .then(async (response) => {
                      console.log(
                        'editDataGlobal DNS_IP + PATH + "edit"',
                        response
                      )

                      this.$swal('สำเร็จ', 'แลกของรางวัลสำเร็จแล้ว', 'success')
                      this.loadingAdd = false
                      this.dialogRedeemForAdmin = false
                      await this.getDataReward(
                        this.DNS_IP,
                        this.path,
                        this.session.data.shopId,
                        this.returnLink
                      )
                      this.clearFormRedeem()
                      this.clear()
                    })
                } else {
                  this.$swal(
                    'ของรางวัลหมดอายุ',
                    'ไม่สามารถแลกของรางวัลได้ เนื่องจากเกินกำหนดวันที่แลกของ',
                    'warning'
                  )
                }
              } else {
                // ไม่มีหมดอายุ
                const params = {
                  redeemStatus: 'use',
                  rewardId: this.formUpdate.rewardId,
                  supply: 'admin',
                  points: this.pointInLevel,
                  img: this.formUpdate.pictureUrl
                }
                axios
                  .post(this.DNS_IP + '/rewardCode/edit', params, {
                    headers: {
                      shopId: this.session.data.shopId,
                      lineUserId: this.dataMember.lineUserId
                        ? this.dataMember.lineUserId
                        : null,
                      lineId: this.dataMember.liffUserId
                        ? this.dataMember.liffUserId
                        : null,
                      memberId: this.dataMember.memberId
                        ? this.dataMember.memberId
                        : null
                    }
                  })
                  .then(async (response) => {
                    console.log(
                      'editDataGlobal DNS_IP + PATH + "edit"',
                      response
                    )

                    this.$swal('สำเร็จ', 'แลกของรางวัลสำเร็จแล้ว', 'success')
                    this.loadingAdd = false
                    this.dialogRedeemForAdmin = false
                    await this.getDataReward(
                      this.DNS_IP,
                      this.path,
                      this.session.data.shopId,
                      this.returnLink
                    )
                    this.clearFormRedeem()
                    this.clear()
                  })
              }
            } else {
              console.log('ไม่พบจำนวน ของรางวัล')
            }
          })
      } catch (error) {
        console.log('ddd')
      }
    },
    onCheckMember () {
      try {
        const cleanedTel = this.checkMember.split('-').join('').trim()
        if (cleanedTel.length > 7) {
          axios
            .get(
              this.DNS_IP +
              '/member/get?shopid=' +
              this.$session.getAll().data.shopId +
              '&tel=' +
              cleanedTel
            )
            .then((res) => {
              console.log('sss', res.data)

              if (res.data.status === false) {
                this.pointInLevel = 0
              } else {
                this.dataMember = res.data[0]
                console.log('this.dataMember', this.dataMember)

                console.log('this.formUpdate.levelSettingsReward', this.formUpdate.levelSettingsReward, parseInt(this.dataMember.levelId))

                if (this.dataMember) {
                  console.log('this.formUpdate.levelSettingsReward', this.formUpdate.levelSettingsReward, parseInt(this.dataMember.levelId))
                  this.formUpdate.levelSettingsReward.find(
                    (el) => {
                      if (el.levelId === parseInt(this.dataMember.levelId)) {
                        console.log(el.points)
                        this.pointInLevel = el.points
                        console.log('enabled', el.enabled)

                        if (!el.enabled) {
                          this.msg =
                      'ไม่สามารถแลกของรางวัลได้เนื่องจากระดับสมาชิกไม่เปิดใช้งาน'
                          this.disRedeem = true
                        } else {
                          this.disRedeem = false
                        }
                      }
                    }
                  )
                }
                if (this.dataMember.currentPoint < this.pointInLevel) {
                  this.disRedeem = true
                  this.msg = 'ไม่สามารถแลกของรางวัลได้เนื่องจากคะแนนไม่พอ'
                }
              }
            })
        }
      } catch (error) {
        console.log('error chec', error)
      }
    },
    async onSelectSuply (val, type) {
      console.log('val', val)

      if (val === '') {
        this.clear()
      } else {
        if (type !== 'edit') {
          this.clear()
        }

        this.formAdd.supply = val
      }
    },
    async onNextStep (step, type) {
      if (step === 2) {
        if (type === 'add') {
          if (this.formAdd.supply !== '') {
            this.steped = step
          }
        } else {
          if (this.formUpdate.supply !== '') {
            this.steped = step
          }
        }
      } else if (step === 3) {
        const isValidStep2 = await this.$refs.formStep2.validate()

        if (isValidStep2) {
          if (type === 'add') {
            await this.getDataLevel()
            if (this.formAdd.supply === 'admin') {
              this.settingsReward = []
              this.dataLevel.map((el) => {
                if (el.levelId !== 'allLevel') {
                  this.settingsReward.push({
                    levelId: el.levelId,
                    levelName: el.name,
                    enabled: false,
                    points: 0
                  })
                }
              })
            }
          } else {
            console.log('isValidStep2', isValidStep2)
          }
          this.steped = step
        }
      } else {
        this.steped = 1
      }
    },
    async onBack (step) {
      if (step !== '') {
        if (step === 1) {
          this.steped = 1
        } else {
        }
      } else {
      }
    },
    selectImg (type) {
      if (type === 'add') {
        if (this.filesAdd) {
          this.formAdd.pictureUrl = URL.createObjectURL(this.filesAdd)
        } else {
          this.formAdd.pictureUrl = ''
        }
      } else {
        if (this.filesUpdate) {
          this.formUpdate.pictureUrl = URL.createObjectURL(this.filesUpdate)
        } else {
          this.formUpdate.pictureUrl = ''
        }
      }
      // console.log(event, type)
      // this.filesAdd = event

      // try {
      //   if (type === 'add') {
      //     if (this.filesAdd) {
      //       this.formAdd.pictureUrl = URL.createObjectURL(this.filesAdd)
      //     } else {
      //       this.formAdd.pictureUrl = ''
      //     }
      //   } else {
      //     if (this.filesAdd) {
      //       this.formUpdate.pictureUrl = URL.createObjectURL(this.filesAdd)
      //     } else {
      //       this.formUpdate.pictureUrl = ''
      //     }
      //   }
      // } catch (error) {
      //   console.log('error func selectImg >>', error)
      //   this.formAdd.pictureUrl = ''
      //   this.formUpdate.pictureUrl = ''
      // }
    },
    clear () {
      this.formAdd.levelSettingsReward = []
      this.formAdd.supply = ''
      this.filesAdd = null
      this.formAdd.pictureUrl = ''
      this.formAdd.name = ''
      this.formAdd.nameEng = ''
      this.formAdd.description = ''
      this.formAdd.descriptionEng = ''
      this.formAdd.point = 0
      this.formAdd.resale = 0
      this.formAdd.levelId = ''
      this.checkboxLevelUpGiveReward = false
      this.formAdd.dataLevelUpgrade = []
      this.formAdd.amountToGive = 0
      this.$refs.formStep2.reset()
      this.$refs.formStep3.reset()
      this.$refs.formPointStep3.reset()
      this.steped = 1
    },
    reset () {
      this.$refs.form.reset()
    },
    async onSubmit (type) {
      if (type === 'add') {
        if (this.formAdd.supply !== 'admin') {
          const isValidStep3 = await this.$refs.formStep3.validate()
          if (isValidStep3) {
            await this.onSubmitSuccess()
          }
        } else {
          const isValidPointStep3 = await this.$refs.formPointStep3.validate()
          if (isValidPointStep3) {
            await this.onSubmitSuccess()
          }
        }
      } else {
        console.log(type)

        if (this.formUpdate.supply !== 'admin') {
          const isValidStep3 = await this.$refs.formStep3.validate()
          if (isValidStep3) {
            await this.onSubmitEditSuccess()
          }
        } else {
          const isValidPointStep3 = await this.$refs.formPointStep3.validate()
          if (isValidPointStep3) {
            await this.onSubmitEditSuccess()
          }
        }
      }
    },
    async onSubmitSuccess () {
      this.dataReady = false
      this.loading = true
      this.dialogAdd = false
      this.$swal({
        title: 'ต้องการ เพิ่มข้อมูล ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async (result) => {
          this.formAdd.CREATE_USER = this.session.data.userName
          this.formAdd.LAST_USER = this.session.data.userName
          if (this.formAdd.supply !== 'admin') {
            var dataCheckLevel = this.dataLevel.filter((el) => {
              return el.levelId === this.formAdd.levelId
            })
            this.formAdd.levelNm = dataCheckLevel[0].name
          }
          if (this.settingsReward.length > 0) {
            this.formAdd.levelSettingsReward = this.settingsReward
            this.settingsReward = []
          }
          if (this.formAdd.name) {
            this.formAdd.name = this.formAdd.name.replace(/'/g, "\\'")
          }
          if (this.formAdd.nameEng) {
            this.formAdd.nameEng = this.formAdd.nameEng.replace(/'/g, "\\'")
          }
          if (this.formAdd.description) {
            this.formAdd.description = this.formAdd.description.replace(
              /'/g,
              "\\'"
            )
          }
          if (this.formAdd.descriptionEng) {
            this.formAdd.descriptionEng = this.formAdd.descriptionEng.replace(
              /'/g,
              "\\'"
            )
          }
          if (this.formAdd.resale === '') {
            this.formAdd.resale = 0
          }
          if (this.checkboxLevelUpGiveReward) {
            if (this.formAdd.dataLevelUpgrade.length > 0) {
              if (this.formAdd.dataLevelUpgrade.length > 0) {
                this.formAdd.supply = 'รับหน้าร้าน'
              }
              this.formAdd.dataLevelUpgrade = JSON.stringify(
                this.formAdd.dataLevelUpgrade
              )
            } else {
              delete this.formAdd['dataLevelUpgrade']
            }
            // this.formAdd.dataLevelUpgrade = JSON.stringify(
            //   this.formAdd.dataLevelUpgrade
            // )
          } else {
            this.formAdd.dataLevelUpgrade = null
          }
          if (this.formAdd.amountToGive === '' || !this.formAdd.amountToGive) {
            delete this.formAdd['amountToGive']
          }
          const _this = this
          let params = new FormData()
          params.append('file', this.filesAdd)
          await axios
            .post(this.DNS_IP + `/file/upload/reward`, params)
            .then((response) => {
              _this.formAdd.pictureUrl = response.data
            })
          delete this.formAdd['pictureUrlPreview']
          if (
            this.session.data.shopId !== 'U4e23f7bf31b362622ff7c5c06dfdf350' &&
            this.formAdd.supply !== 'รับหน้าร้าน'
          ) {
            delete this.formAdd['BvpExpieMinAfterUse']
          }
          this.dialogAdd = false
          this.formAdd.levelSettingsReward = JSON.stringify(
            this.formAdd.levelSettingsReward
          )
          await axios
            .post(this.DNS_IP + '/reward/add', this.formAdd)
            .then(async (response) => {
              if (response.data.status === true) {
                this.$swal('เรียบร้อย', 'เพิ่มข้อมูล เรียบร้อย', 'success')
                this.steped = 1
                await this.getDataReward(
                  this.DNS_IP,
                  this.path,
                  this.session.data.shopId,
                  this.returnLink
                )
                await this.clear()
                this.loading = false
              } else {
                this.$swal('ไม่สำเร็จ', 'เพิ่มข้อมูล ไม่สำเร็จ', 'warning')
                this.loading = false
                await this.clear()
              }
            })
        })
        .catch((error) => {
          console.log('error function addData : ', error)
          this.dataReady = true
          this.loading = false
          this.clear()
        })
    },
    async onSubmitEditSuccess () {
      this.dataReady = false
      this.loading = true
      this.dialogEdit = false
      this.$swal({
        title: 'ต้องการ แก้ไขข้อมูล ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async (result) => {
          this.loadingEdit = true
          this.formUpdate.LAST_USER = this.session.data.userName
          if (this.formAdd.levelId !== '') {
            var levelId = this.formUpdate.levelId
            var dataCheckLevel = this.dataLevel.filter(function (el) {
              return el.value === levelId
            })
            this.formUpdate.levelNm = dataCheckLevel[0].text
          }
          if (this.formUpdate.name) {
            this.formUpdate.name = this.formUpdate.name.replace(/'/g, "\\'")
          }
          if (this.formUpdate.nameEng) {
            this.formUpdate.nameEng = this.formUpdate.nameEng.replace(
              /'/g,
              "\\'"
            )
          }
          if (this.formUpdate.description) {
            this.formUpdate.description = this.formUpdate.description.replace(
              /'/g,
              "\\'"
            )
          }
          if (this.formUpdate.descriptionEng) {
            this.formUpdate.descriptionEng =
              this.formUpdate.descriptionEng.replace(/'/g, "\\'")
          }

          var ID = this.formUpdate.rewardId
          if (this.filesUpdate) {
            const _this = this
            let params = new FormData()
            params.append('file', this.filesUpdate)

            await axios
              .post(this.DNS_IP + `/file/upload/reward`, params)
              .then(function (response) {
                _this.formUpdate.pictureUrl = response.data
                console.log('url Pic', response.data)
              })
          } else {
            this.formUpdate.pictureUrl = this.formUpdate.pictureUrlPreview
          }
          if (this.checkboxLevelUpGiveReward) {
            if (this.formUpdate.dataLevelUpgrade) {
              if (this.formUpdate.dataLevelUpgrade.length > 0) {
                this.formUpdate.supply = 'รับหน้าร้าน'
                this.formUpdate.dataLevelUpgrade =
                  this.formUpdate.dataLevelUpgrade
              } else {
                this.formUpdate.dataLevelUpgrade = null
              }
              this.formUpdate.dataLevelUpgrade = JSON.stringify(
                this.formUpdate.dataLevelUpgrade
              )
            }
          } else {
            this.formUpdate.dataLevelUpgrade = null
          }
          this.formUpdate.levelSettingsReward = JSON.stringify(
            this.formUpdate.levelSettingsReward
          )
          delete this.formUpdate['pictureUrlPreview']
          delete this.formUpdate['rewardId']
          delete this.formUpdate['LAST_DATE']
          delete this.formUpdate['CREATE_DATE']
          delete this.formUpdate['startDate']
          delete this.formUpdate['endDate']
          delete this.formUpdate['quotaCode']
          delete this.formUpdate['title']
          delete this.formUpdate['levelName']
          delete this.formUpdate['levelPoint']
          console.log('this.formUpdate', this.formUpdate)
          await axios
            .post(this.DNS_IP + this.path + 'edit/' + ID, this.formUpdate)
            .then(async (response) => {
              // Debug response

              this.$swal('เรียบร้อย', 'แก้ไขข้อมูล เรียบร้อย', 'success')
              // Close Dialog
              // this.dialogEdit = false
              this.loading = false

              // Load Data
              // await this.reloadData()

              await this.clearDataUpdate()
              this.filesUpdate = null
              await this.getDataReward(
                this.DNS_IP,
                this.path,
                this.session.data.shopId,
                this.returnLink
              )
              this.steped = 1
            })
            // eslint-disable-next-line handle-callback-err
            .catch((error) => {
              this.dataReady = true
              this.loading = false
              console.log('error function editDataGlobal : ', error)
              // this.$router.push(
              //   '/system/Errorpage?returnLink=' + this.returnLink
              // )
            })
        })
        .catch((error) => {
          this.dataReady = true
          this.loading = false
          console.log('error function editDataGlobal2 : ', error)
        })
    },
    async getDataLevel () {
      this.dataLevel = []
      await axios
        .get(this.DNS_IP + '/level/get?shopId=' + this.session.data.shopId)
        .then(async (response) => {
          let rs = response.data
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            d.text = d.name
            d.value = d.levelId
            this.dataLevel.push(d)
            this.resLevel.push(d)
          }
          this.dataLevel.push({
            text: 'All Level',
            value: 'allLevel',
            levelId: 'allLevel'
          })
          console.log('dataLevel', this.dataLevel)
        })
        .catch((error) => {
          console.log(error)
          this.dataLevel = []
          this.dataReady = true
        })
    },
    async changeExpire () {
      console.log(this.formUpdateQuata)
      this.loading = true
      this.$swal({
        title: 'ต้องการ เปลี่ยนวันหมดอายุ ใช่หรือไม่?',
        icon: 'question', // ใช้ icon แทน type (type deprecated แล้ว)
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async (result) => {
          console.log(!result)

          // if (!result.isConfirmed) {
          //   console.log('ผู้ใช้กดยกเลิก')
          //   this.loading = false
          //   this.dialogChangeExpireDate = false
          //   return
          // }
          try {
            console.log('tryyyy')

            const url1 =
              this.DNS_IP +
              '/reward/changExpire/' +
              this.formUpdateQuata.rewardId
            await axios
              .post(url1, this.formUpdateQuata)
              .then(async (response) => {
                if (response.data.status === true) {
                  this.$swal({
                    title: 'เรียบร้อย',
                    type: 'success',
                    showCancelButton: false,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#b3b1ab',
                    confirmButtonText: 'ตกลง'
                  })
                    .then(async (result) => {
                      console.log(result)
                      this.dialogChangeExpireDate = false
                      this.dataReady = false
                      this.loading = false
                      await this.getDataReward()
                    })
                    .catch((error) => {
                      this.loading = false
                      console.log(error)
                    })
                } else {
                  this.loading = false
                  this.$swal('ผิดพลาด', response.data.message, 'error')
                  this.$router.push('/Master/reward')
                  location.reload()
                }
              })
          } catch (error) {
            this.loading = false
            console.log('errir', error)
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)

          this.dataReady = true
          this.loading = false
          this.dialogChangeExpireDate = false
        })
    },
    checkChangeExpire () {
      if (this.formUpdateQuata.expireType === 'Redeem') {
        if (
          !this.formUpdateQuata.countExpire ||
          this.formUpdateQuata.countExpire <= 0
        ) {
          return true
        } else {
          return false
        }
      } else {
        if (
          !this.formUpdateQuata.startDate ||
          !this.formUpdateQuata.endDate ||
          this.formUpdateQuata.startDate === '' ||
          this.formUpdateQuata.endDate === ''
        ) {
          return true
        } else {
          return false
        }
      }
    },
    clearDataChangeExpire () {
      this.formUpdateQuata = {
        prefix: '',
        rewardCode: '',
        count: '',
        CREATE_USER: '',
        LAST_USER: '',
        shopId: this.$session.getAll().data.shopId,
        rewardId: '',
        startDate: '',
        endDate: '',
        expireType: '',
        countExpire: '',
        genType: '',
        redeemStatus: ''
      }
    },
    checkRadioLevelUpgrade () {
      console.log(')ddddd')
      if (this.formAdd.dataLevelUpgrade) {
        if (
          this.formAdd.dataLevelUpgrade.length > 0 &&
          this.checkboxLevelUpGiveReward === true
        ) {
          console.log(')ddddd')
          this.formAdd.supply = 'รับหน้าร้าน'
          this.statusRadioLevelUpgrade = true
        } else {
          this.statusRadioLevelUpgrade = false
        }
      } else {
        this.statusRadioLevelUpgrade = false
      }
      console.log(this.statusRadioLevelUpgrade)
    },
    checkLevelUpgrade () {
      if (this.formAdd.dataLevelUpgrade) {
        if (this.formAdd.dataLevelUpgrade.length > 0) {
          this.formAdd.supply = 'รับหน้าร้าน'
          this.statusRadioLevelUpgrade = true
        } else {
          this.statusRadioLevelUpgrade = false
        }
      } else {
        this.statusRadioLevelUpgrade = false
      }
    },
    checkRadioLevelUpgradeEdit () {
      console.log(')ddddd')
      if (this.formUpdate.dataLevelUpgrade) {
        if (
          this.formUpdate.dataLevelUpgrade.length > 0 &&
          this.checkboxLevelUpGiveReward === true
        ) {
          console.log(')ddddd')
          this.formUpdate.supply = 'รับหน้าร้าน'
          this.statusRadioLevelUpgrade = true
          console.log(')ddddd', this.formUpdate.supply)
        } else {
          this.statusRadioLevelUpgrade = false
        }
      } else {
        this.statusRadioLevelUpgrade = false
      }
      console.log(')ddddd', this.statusRadioLevelUpgrade)
    },
    checkLevelUpgradeEdit () {
      if (this.formUpdate.dataLevelUpgrade) {
        if (this.formUpdate.dataLevelUpgrade.length > 0) {
          this.formUpdate.supply = 'รับหน้าร้าน'
          this.statusRadioLevelUpgrade = true
        } else {
          this.statusRadioLevelUpgrade = false
        }
      } else {
        this.statusRadioLevelUpgrade = false
      }
    },
    validate () {
      this.$refs.formadd.validate()
    },
    parseDate (date) {
      if (!date) return null

      const [month, day, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    async check () {
      this.dddd = !this.dddd
      console.log(' this.dddd', this.dddd)
    },
    chkSupply () {
      axios
        .get(this.DNS_IP + '/reward/getID?rewardId=' + this.item.rewardId)
        .then((response) => {
          let rs = response.data
          console.log('555', rs)
        })
    },

    async importData (event) {
      this.dataItemImport = []
      var input = event.target
      var reader = new FileReader()
      reader.onload = () => {
        var fileData = reader.result
        var wb = XLSX.read(fileData, { type: 'binary' })
        wb.SheetNames.forEach(async (sheetName) => {
          var rowObj = XLSX.utils.sheet_to_json(wb.Sheets[sheetName])
          console.log('aa', rowObj)
          // this.dataItemImport = rowObj
          for (var i = 0; i < rowObj.length; i++) {
            var d = rowObj[i]
            await axios
              .get(
                // eslint-disable-next-line quotes
                this.DNS_IP +
                  '/rewardCode/' +
                  'get?rewardId=' +
                  this.formUpdate.rewardId +
                  '&rewardCode=' +
                  d.rewardCode
              )
              .then(async (response) => {
                console.log('data', response)
                if (response.data.status === false) {
                  rowObj
                    .map((e) => {
                      return e.rewardCode
                    })
                    .indexOf(d.rewardCode) === i
                    ? (d.status = 'True')
                    : (d.status = 'False')
                } else {
                  d.status = 'False'
                }
              })
            this.dataItemImport.push(d)
            console.log('dataItem', this.dataItemImport)
          }
          console.log('this.dataItemImport : ', this.dataItemImport)
          if (this.dataItemImport.length === 0) {
            alert('โปรดใส่ไฟล์ให้ถูกต้อง')
          } else {
            this.dataItemImportChecKHide = false
          }
        })
      }

      reader.readAsBinaryString(input.files[0])
    },
    resetType () {
      if (this.formImport1.expireType === 'FixDate') {
        this.formImport1.startDate = ''
        this.formImport1.endDate = ''
      } else {
        this.formImport1.countExpire = 0
      }
    },
    async changExpirePackage () {
      this.$swal({
        title: 'ต้องการ เปลี่ยนวันหมดอายุ ใช่หรือไม่?',
        text: 'เปลี่ยนเป็นวันที่ ' + this.pickerChangeExpire,
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async (result) => {
          console.log('result', this.dataReward)
          console.log('result', this.pickerChangeExpire)
          // const timestamp = new Date(this.pickerChangeExpire).getTime() / 1000
          // console.log(timestamp)
          try {
            const url1 =
              this.DNS_IP + '/reward/editExpire/' + this.dataReward.rewardId
            let dt1 = {
              endDate: this.pickerChangeExpire
            }
            await axios.post(url1, dt1).then(async (response) => {
              if (response.data.status === true) {
                this.$swal({
                  title: 'เรียบร้อย',
                  type: 'success',
                  showCancelButton: false,
                  confirmButtonColor: '#3085d6',
                  cancelButtonColor: '#b3b1ab',
                  confirmButtonText: 'ตกลง'
                })
                  .then(async (result) => {
                    console.log(result)
                    this.dialogChangeExpire = false
                    this.dataReady = false
                    await this.getDataReward()
                  })
                  .catch((error) => {
                    console.log(error)
                  })
              } else {
                this.$swal('ผิดพลาด', response.data.message, 'error')
                this.$router.push('/Master/reward')
                location.reload()
              }
            })
          } catch (error) {
            console.log('errir', error)
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.dataReady = true
        })
    },
    async getDataImport (dt) {
      this.dataReadyView = false
      this.dataItemView = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/rewardCode/" + "get?rewardId=" + dt.rewardId
        )
        .then(async (response) => {
          let rs = response.data
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            // if (d.expireType === 'Redeem') {
            //   d.startDate = ''
            //   d.endDate = ''
            // }
            this.dataItemView.push(d)
          }
        })
      this.dataReadyView = true
    },
    async getDataReward () {
      try {
        this.dataItem = []
        this.dataItemImport = []

        await axios
          .get(this.DNS_IP + this.path + 'get?shopId=' + this.session.data.shopId)
          .then(async (response) => {
            console.log('getData', response.data)
            let rs = response.data
            this.dataItem = response.data

            this.dataItem.forEach(el => {
              if (el.levelId === 'allLevel') {
                el.levelNm = 'All Level'
              } else {
                if (typeof el.levelId === 'string') {
                  // console.log('>>>>>>', typeof parseInt(el.levelId))
                  const matched = this.dataLevel.find(item => {
                    // console.log(el.name, el.supply, parseInt(el.levelId), item.levelId, parseInt(el.levelId) === item.levelId)
                    return parseInt(el.levelId) === item.levelId
                  })
                  console.log('matched', matched)

                  el.levelNm = matched ? matched.name : null
                  console.log('el.levelNm', el.levelNm)
                }
              }
            })

            // this.dataItem.levelNm
            this.formUpdate.rewardId = rs.rewardId
            console.log('rewardid', this.formUpdate.rewardId)
            console.log('getData', this.dataItem)

            this.dataReady = true
            this.export_data = response.data
            if (Array.isArray(response.data)) {
              let a = response.data.find((item) => {
                return (
                  new Date().getTime() > new Date(item.endDate).getTime() &&
                item.expireTypeReward === 'FixDate'
                )
              })

              if (a) {
                this.boolenAlert = true
              } else {
                this.boolenAlert = false
              }
            }
          })
        // eslint-disable-next-line handle-callback-err
          .catch((error) => {
            console.log(error)
            // this.$swal('ผิดพลาด', 'ไม่มีข้อมูล', 'error')
            // this.$router.push('/system/Errorpage?returnLink=' + this.returnLink)
            this.dataReady = true
          })
      } catch (error) {
        console.log('err getDataReward', error)
      }
    },
    selectImgUpdate (event) {
      if (this.filesUpdate) {
        this.formUpdate.pictureUrlPreview = URL.createObjectURL(
          this.filesUpdate
        )
      } else {
        this.formUpdate.pictureUrlPreview = ''
      }
      // console.log(event)
    },

    async searchDataAll () {
      var search =
        '?rewardId=' +
        this.searchAll +
        '&name=' +
        this.searchAll +
        '&Point=' +
        this.searchAll +
        '&priviledge=' +
        this.searchAll
      this.dataReady = false
      this.searchDataAllGlobal(this.DNS_IP, this.path, search, this.returnLink)
    },
    getDataItem (item, type) {
      if (type === 'add') {
        this.dialogUpdateQuata = true
        this.formUpdateQuata.expireType = item.expireTypeReward
        this.formUpdateQuata.rewardId = item.rewardId
        this.formUpdateQuata.countExpire = item.countExpire
        this.formUpdateQuata.startDate = moment(String(item.startDate)).format(
          'YYYY-MM-DD'
        )
        this.formUpdateQuata.endDate = moment(String(item.endDate)).format(
          'YYYY-MM-DD'
        )
      } else {
        this.dialogChangeExpireDate = true
        this.formUpdateQuata.expireType = item.expireTypeReward
        this.formUpdateQuata.rewardId = item.rewardId
        this.formUpdateQuata.countExpire = item.countExpire
        if (this.formUpdateQuata.expireType === 'FixDate') {
          this.formUpdateQuata.startDate = moment(
            String(item.startDate)
          ).format('YYYY-MM-DD')
          this.formUpdateQuata.endDate = moment(String(item.endDate)).format(
            'YYYY-MM-DD'
          )
        }
      }
      // this.formUpdateQuata.endtDate = item.endtDate
      // console.log('res1750', this.item.startDate)
      // axios
      //   .get(this.DNS_IP + this.path + 'getID?rewardId=' + item.rewardId)
      //   .then((res) => {
      //     this.dataGetForAddReward = res.data
      //     this.dialogUpdateQuata = true
      //     console.log('res1750', this.dataGetForAddReward)
      //   })
    },
    async getDataById (item, type) {
      try {
        this.dataReady = false
        await this.getDataByIdGlobal(
          this.DNS_IP,
          this.path,
          'rewardId',
          item.rewardId,
          this.returnLink
        )
        if (this.formUpdate.showReward === 'True') {
          this.formUpdate.showReward = true
        } else {
          this.formUpdate.showReward = false
        }
        if (this.formUpdate.levelSettingsReward) {
          this.formUpdate.levelSettingsReward = JSON.parse(
            this.formUpdate.levelSettingsReward
          )
          console.log('levelSettingsReward >>>>', this.formUpdate.levelSettingsReward)
        }

        if (this.formUpdate.dataLevelUpgrade) {
          this.formUpdate.dataLevelUpgrade = JSON.parse(
            this.formUpdate.dataLevelUpgrade
          )
          if (this.formUpdate.dataLevelUpgrade.length > 0) {
            this.statusRadioLevelUpgrade = true
            this.checkboxLevelUpGiveReward = true
          }
        }
        this.formUpdate.startDate = moment(
          String(this.formUpdate.startDate)
        ).format('YYYY-MM-DD')
        this.formUpdate.endDate = moment(
          String(this.formUpdate.endDate)
        ).format('YYYY-MM-DD')
        this.formUpdate.pictureUrlPreview = this.formUpdate.pictureUrl
        if (
          this.formUpdate.levelId !== 'allLevel' &&
          this.formUpdate.levelId !== ''
        ) {
          this.formUpdate.levelId = parseInt(this.formUpdate.levelId)
        }
        if (type === 'edit') {
          this.dialogEdit = true
          this.validate('UPDATE')
        } else if (type === 'delete') {
          this.dialogDelete = true
        } else if (type === 'redeem') {
          this.dialogRedeemForAdmin = true
          this.levelActive = this.formUpdate.levelSettingsReward
            .filter((i) => i.enabled)
            .map((i) => i.levelName)
            .join(', ')
        }
      } catch (error) {
        console.log('error', error)
      }
    },
    createCode () {
      if (this.formImport1.count <= 0) {
        this.$swal('ไม่สำเร็จ', 'กรุณาเพิ่มจำนวนของรางวัล', 'warning')
        console.log(this.$refs.form.validate())
      } else {
        if (this.$refs.form.validate() === false) {
          this.$swal('ไม่สำเร็จ', 'กรุณากำหนดวันหมดอายุ', 'warning')
        } else {
          this.$swal({
            title: 'ต้องการ สร้าง Code ใช่หรือไม่?',
            type: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#b3b1ab',
            confirmButtonText: 'ใช่',
            cancelButtonText: 'ไม่'
          }).then(async (result) => {
            this.loading = true
            this.formImport1.genType = 'gen'
            this.formImport1.CREATE_USER = this.session.data.userName
            this.formImport1.LAST_USER = this.session.data.userName
            this.formImport1.rewardId = this.formUpdate.rewardId
            console.log('this.formImport1.rewardId ', this.formUpdate.rewardId)
            this.formImport1.redeemStatus = 'open'
            if (this.formImport1.expireType === 'Redeem') {
              this.formImport1.startDate = ''
              this.formImport1.endDate = ''
            }
            this.formImport1.prefix = Date.now().toString().substr(9, 13)
            console.log('this.formImport1', this.formImport1)
            console.log('formUpdateQuata', this.formUpdateQuata)
            await axios
              .post(this.DNS_IP + '/rewardCode/' + 'add', this.formImport1)
              .then(async (response) => {
                this.formStatus.fail = response.data.fail
                this.formStatus.sucess = response.data.sucess
                this.formStatus.dataStatus = response.data.dataStatus
                this.loading = false
                this.dialogStatus = true
                await this.clearDataImport()
              })

            this.dialogImport = false
            this.filesAdd = null
            await this.getDataReward(
              this.DNS_IP,
              this.path,
              this.session.data.shopId,
              this.returnLink
            )
          })
          // }
        }
      }
    },
    addCode () {
      if (this.formUpdateQuata.count <= 0) {
        this.$swal('ไม่สำเร็จ', 'กรุณาเพิ่มจำนวนของรางวัล', 'warning')
        console.log(this.$refs.form.validate())
      } else {
        if (this.$refs.form_UpdateQuata.validate() === false) {
          this.$swal('ไม่สำเร็จ', 'กรุณากำหนดวันหมดอายุ', 'warning')
        } else {
          this.$swal({
            title: 'ต้องการ สร้าง Code ใช่หรือไม่?',
            type: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#b3b1ab',
            confirmButtonText: 'ใช่',
            cancelButtonText: 'ไม่'
          }).then(async (result) => {
            this.loading = true
            this.formUpdateQuata.genType = 'gen'
            this.formUpdateQuata.CREATE_USER = this.session.data.userName
            this.formUpdateQuata.LAST_USER = this.session.data.userName
            this.formUpdateQuata.redeemStatus = 'open'
            if (this.formUpdateQuata.expireType === 'Redeem') {
              this.formUpdateQuata.startDate = ''
              this.formUpdateQuata.endDate = ''
            }
            this.formUpdateQuata.prefix = Date.now().toString().substr(9, 13)
            console.log('this.formUpdateQuata', this.formUpdateQuata)
            await axios
              .post(this.DNS_IP + '/rewardCode/' + 'add', this.formUpdateQuata)
              .then(async (response) => {
                this.formStatus.fail = response.data.fail
                this.formStatus.sucess = response.data.sucess
                this.formStatus.dataStatus = response.data.dataStatus
                this.loading = false
                this.dialogStatus = true
                await this.clearDataAddcode()
              })

            this.dialogUpdateQuata = false
            // this.filesAdd = null
            await this.getDataReward(
              this.DNS_IP,
              this.path,
              this.session.data.shopId,
              this.returnLink
            )
          })
          // }
        }
      }
    },
    async updateQuata () {
      await axios.get(this.DNS_IP + /reward/).then()
    },
    async addData () {
      if (this.$refs.formadd.validate() === true) {
        this.dataReady = false
        this.$swal({
          title: 'ต้องการ เพิ่มข้อมูล ใช่หรือไม่?',
          type: 'question',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#b3b1ab',
          confirmButtonText: 'ใช่',
          cancelButtonText: 'ไม่'
        })
          .then(async (result) => {
            // this.loadingAdd = true
            var levelId = this.formAdd.levelId
            var dataCheckLevel = this.dataLevel.filter(function (el) {
              return el.value === levelId
            })
            // this.formAdd.name = this.formAdd.name.replace(/'/g, "\\'")
            // this.formAdd.nameEng = this.formAdd.nameEng.replace(/'/g, "\\'")
            // this.formAdd.description = this.formAdd.description.replace(/'/g, "\\'")
            // this.formAdd.descriptionEng = this.formAdd.descriptionEng.replace(/'/g, "\\'")
            if (this.formAdd.name) {
              this.formAdd.name = this.formAdd.name.replace(/'/g, "\\'")
            }
            if (this.formAdd.nameEng) {
              this.formAdd.nameEng = this.formAdd.nameEng.replace(/'/g, "\\'")
            }
            if (this.formAdd.description) {
              this.formAdd.description = this.formAdd.description.replace(
                /'/g,
                "\\'"
              )
            }
            if (this.formAdd.descriptionEng) {
              this.formAdd.descriptionEng = this.formAdd.descriptionEng.replace(
                /'/g,
                "\\'"
              )
            }

            this.formAdd.levelNm = dataCheckLevel[0].text
            this.formAdd.CREATE_USER = this.session.data.userName
            this.formAdd.LAST_USER = this.session.data.userName
            if (this.formAdd.resale === '') {
              this.formAdd.resale = 0
            }
            const _this = this
            let params = new FormData()
            params.append('file', this.filesAdd)
            console.log('params', params)

            if (this.checkboxLevelUpGiveReward) {
              if (this.formAdd.dataLevelUpgrade.length > 0) {
                if (this.formAdd.dataLevelUpgrade.length > 0) {
                  this.formAdd.supply = 'รับหน้าร้าน'
                  console.log(this.formAdd.amountToGive)
                }
                this.formAdd.dataLevelUpgrade = JSON.stringify(
                  this.formAdd.dataLevelUpgrade
                )
              } else {
                delete this.formAdd['dataLevelUpgrade']
              }
              // this.formAdd.dataLevelUpgrade = JSON.stringify(
              //   this.formAdd.dataLevelUpgrade
              // )
            } else {
              this.formAdd.dataLevelUpgrade = null
            }
            if (
              this.formAdd.amountToGive === '' ||
              !this.formAdd.amountToGive
            ) {
              delete this.formAdd['amountToGive']
            }
            console.log('addparams', params)

            await axios
              .post(this.DNS_IP + `/file/upload/reward`, params)
              .then(function (response) {
                _this.formAdd.pictureUrl = response.data
                console.log('url Pic', response.data)
              })
            delete this.formAdd['pictureUrlPreview']
            if (
              this.session.data.shopId !==
                'U4e23f7bf31b362622ff7c5c06dfdf350' &&
              this.formAdd.supply !== 'รับหน้าร้าน'
            ) {
              delete this.formAdd['BvpExpieMinAfterUse']
            }
            await axios
              .post(this.DNS_IP + this.path + 'add', this.formAdd)
              .then(async (response) => {
                // Debug response
                console.log('addDataGlobal DNS_IP + PATH + "add"', response)

                this.$swal('เรียบร้อย', 'เพิ่มข้อมูล เรียบร้อย', 'success')
                // Close Dialog
                this.dialogAdd = false

                // Load Data
                await this.clearData()
                this.filesAdd = null
                await this.getDataReward(
                  this.DNS_IP,
                  this.path,
                  this.session.data.shopId,
                  this.returnLink
                )
                this.loadingAdd = false
              })
              // eslint-disable-next-line handle-callback-err
              .catch((error) => {
                console.log('error function addDataGlobal : ', error)
                this.$router.push(
                  '/system/Errorpage?returnLink=' + this.returnLink
                )
                this.dataReady = true
              })
          })
          .catch((error) => {
            console.log('error function addData : ', error)
            this.dataReady = true
          })
      }
    },
    async editData () {
      // this.editDataGlobal(this.DNS_IP, this.path, this.PK, this.formUpdateItem)
      this.dataReady = false
      this.$swal({
        title: 'ต้องการ แก้ไขข้อมูล ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async (result) => {
          this.loadingEdit = true
          this.formUpdate.LAST_USER = this.session.data.userName
          var levelId = this.formUpdate.levelId
          var dataCheckLevel = this.dataLevel.filter(function (el) {
            return el.value === levelId
          })
          console.log(
            'dataCheckLevel',
            dataCheckLevel,
            levelId,
            this.dataLevel
          )
          if (this.formUpdate.name) {
            this.formUpdate.name = this.formUpdate.name.replace(/'/g, "\\'")
          }
          if (this.formUpdate.nameEng) {
            this.formUpdate.nameEng = this.formUpdate.nameEng.replace(
              /'/g,
              "\\'"
            )
          }
          if (this.formUpdate.description) {
            this.formUpdate.description = this.formUpdate.description.replace(
              /'/g,
              "\\'"
            )
          }
          if (this.formUpdate.descriptionEng) {
            this.formUpdate.descriptionEng =
              this.formUpdate.descriptionEng.replace(/'/g, "\\'")
          }
          // this.formUpdate.name = this.formUpdate.name.replace(/'/g, "\\'")
          // this.formUpdate.nameEng = this.formUpdate.nameEng.replace(/'/g, "\\'")
          // this.formUpdate.description = this.formUpdate.description.replace(/'/g, "\\'")
          // this.formUpdate.descriptionEng = this.formUpdate.descriptionEng.replace(/'/g, "\\'")
          this.formUpdate.levelNm = dataCheckLevel[0].text
          var ID = this.formUpdate.rewardId
          if (this.filesUpdate) {
            const _this = this
            let params = new FormData()
            params.append('file', this.filesUpdate)

            await axios
              .post(this.DNS_IP + `/file/upload/reward`, params)
              .then(function (response) {
                _this.formUpdate.pictureUrl = response.data
                console.log('url Pic', response.data)
              })
          } else {
            this.formUpdate.pictureUrl = this.formUpdate.pictureUrlPreview
          }
          if (this.checkboxLevelUpGiveReward) {
            if (this.formUpdate.dataLevelUpgrade) {
              if (this.formUpdate.dataLevelUpgrade.length > 0) {
                // if (this.formUpdate.dataLevelUpgrade.length > 0) {
                this.formUpdate.supply = 'รับหน้าร้าน'
                console.log(this.formUpdate.amountToGive)
                // }
                this.formUpdate.dataLevelUpgrade =
                  this.formUpdate.dataLevelUpgrade
              } else {
                this.formUpdate.dataLevelUpgrade = null
              }
              this.formUpdate.dataLevelUpgrade = JSON.stringify(
                this.formUpdate.dataLevelUpgrade
              )
            }
          } else {
            this.formUpdate.dataLevelUpgrade = null
          }
          delete this.formUpdate['pictureUrlPreview']
          delete this.formUpdate['rewardId']
          delete this.formUpdate['LAST_DATE']
          delete this.formUpdate['CREATE_DATE']
          delete this.formUpdate['startDate']
          delete this.formUpdate['endDate']
          delete this.formUpdate['quotaCode']
          delete this.formUpdate['title']
          delete this.formUpdate['levelName']
          delete this.formUpdate['levelPoint']
          console.log('this.formUpdate', this.formUpdate)
          await axios
            .post(
              // eslint-disable-next-line quotes
              this.DNS_IP + this.path + "edit/" + ID,
              this.formUpdate
            )
            .then(async (response) => {
              // Debug response
              console.log('editDataGlobal DNS_IP + PATH + "edit"', response)

              this.$swal('เรียบร้อย', 'แก้ไขข้อมูล เรียบร้อย', 'success')
              // Close Dialog
              this.dialogEdit = false

              // Load Data
              // await this.reloadData()
              await this.clearDataUpdate()
              this.filesUpdate = null
              await this.getDataReward(
                this.DNS_IP,
                this.path,
                this.session.data.shopId,
                this.returnLink
              )
              this.loadingEdit = false
            })
            // eslint-disable-next-line handle-callback-err
            .catch((error) => {
              this.dataReady = true
              console.log('error function editDataGlobal : ', error)
              this.$router.push(
                '/system/Errorpage?returnLink=' + this.returnLink
              )
            })
        })
        .catch((error) => {
          this.dataReady = true
          console.log('error function editDataGlobal4 : ', error)
        })
    },
    async deleteData () {
      this.formUpdate.LAST_USER = this.session.data.userName
      console.log('DELETE PK : ', this.formUpdate.rewardId)
      //
      //
      // สำหรับ ลบข้อมูล
      // ต้องระบุ  Last User ว่าใครเป็นคนลบล่าสุด
      //
      // this.formUpdate.LAST_USER = this.$session.getAll().data.userName
      this.dataReady = false
      await this.deleteDataSubmit(
        this.DNS_IP,
        this.path,
        this.formUpdate.rewardId,
        this.session.data.shopId,
        '',
        this.returnLink
      )
    },
    async deleteDataSubmit (DNS_IP, PATH, ID, shopId, status, returnLink) {
      this.$swal({
        title: 'ต้องการ ลบข้อมูล ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#fa0202',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async (result) => {
          await axios
            .post(
              // eslint-disable-next-line quotes
              DNS_IP + PATH + "delete/" + ID,
              this.formUpdate,
              {
                headers: {
                  'Application-Key': this.$session.getAll().ApplicationKey
                }
              }
            )
            .then(async (response) => {
              // Debug response
              console.log('DNS_IP + PATH + "delete/"', response)
              console.log('status', status)

              this.$swal('เรียบร้อย', 'ลบข้อมูลเรียบร้อย', 'success')
              // Close Dialog
              this.dialogDelete = false

              // Load Data
              await this.getDataReward(
                this.DNS_IP,
                this.path,
                this.session.data.shopId,
                this.returnLink
              )
            })
            // eslint-disable-next-line handle-callback-err
            .catch((error) => {
              this.dataReady = true
              this.$swal('ผิดพลาด', 'ผิดพลาด -1', 'error')
              console.log('error function deleteDataGlobal : ', error)
              this.$router.push('/system/Errorpage?returnLink=' + returnLink)
            })
        })
        .catch((error) => {
          this.dataReady = true
          this.$swal('ผิดพลาด', 'ผิดพลาด -2', 'error')
          console.log('error function deleteDataGlobal : ', error)
        })
    },
    async clearData () {
      this.formAdd.name = ''
      this.formAdd.subName = ''
      this.formAdd.point = 0
      this.formAdd.quota = 0
      this.formAdd.description = ''
      this.formAdd.CREATE_USER = ''
      this.formAdd.LAST_USER = ''
      this.formAdd.pictureUrl = ''
      this.formAdd.pictureUrlPreview = ''
      this.formAdd.trending = 'False'
      this.formAdd.most = 'False'
      this.formAdd.specialOffer = 'False'
      this.formAdd.shopId = this.$session.getAll().data.shopId
      this.formAdd.levelNm = ''
      this.formAdd.levelId = ''
      this.formAdd.supply = 'รับหน้าร้าน'
      this.formAdd.descriptionEng = ''
      this.formAdd.nameEng = ''
      this.formAdd.dataLevelUpgrade = []
      this.formAdd.showReward = true
      this.statusRadioLevelUpgrade = false
      this.checkboxLevelUpGiveReward = false
      this.$forceUpdate()
      console.log('dddjnckfjwerbfjehrb2', this.formAdd.showReward)
    },
    async clearDataAddcode () {
      this.formUpdateQuata.prefix = ''
      this.formUpdateQuata.rewardCode = ''
      this.formUpdateQuata.count = 0
      this.formUpdateQuata.CREATE_USER = ''
      this.formUpdateQuata.LAST_USER = ''
      this.formUpdateQuata.shopId = this.$session.getAll().data.shopId
      this.formUpdateQuata.rewardId = ''
      this.formUpdateQuata.startDate = ''
      this.formUpdateQuata.endDate = ''
      this.formUpdateQuata.expireType = 'FixDate'
      this.formUpdateQuata.countExpire = 0
      this.formUpdateQuata.genType = ''
      this.formUpdateQuata.redeemStatus = ''
      this.statusRadioLevelUpgrade = false
      this.checkboxLevelUpGiveReward = false
    },
    async clearDataUpdate () {
      this.formUpdate.rewardId = ''
      this.formUpdate.name = ''
      this.formUpdate.subName = ''
      this.formUpdate.point = 0
      this.formUpdate.quota = 0
      this.formUpdate.description = ''
      this.formUpdate.LAST_USER = ''
      this.formUpdate.pictureUrl = ''
      this.formUpdate.pictureUrlPreview = ''
      this.formUpdate.trending = 'False'
      this.formUpdate.most = 'False'
      this.formUpdate.specialOffer = 'False'
      this.formUpdate.shopId = ''
      this.formUpdate.levelNm = ''
      this.formUpdate.levelId = 'allLevel'
      this.formAdd.descriptionEng = ''
      this.formAdd.nameEng = ''
      this.formAdd.dataLevelUpgrade = []
      this.statusRadioLevelUpgrade = false
      this.formAdd.showReward = true
      this.checkboxLevelUpGiveReward = false
    },
    async clearDataImport () {
      this.formImport1.prefix = ''
      this.formImport1.rewardCode = ''
      this.formImport1.count = 0
      this.formImport1.CREATE_USER = ''
      this.formImport1.LAST_USER = ''
      this.formImport1.shopId = this.$session.getAll().data.shopId
      this.formImport1.rewardId = ''
      this.formImport1.startDate = ''
      this.formImport1.endDate = ''
      this.formImport1.expireType = 'FixDate'
      this.formImport1.countExpire = 0
      this.formImport1.genType = ''
      this.formImport1.redeemStatus = ''
    },
    importDataApprove (action) {
      var checkError = false

      this.$swal({
        title: 'ท่านต้องการ นำเข้าข้อมูลจากไฟล์นี้ ใช่หรือไม่',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async (result) => {
          this.loading1 = true
          this.formStatus.dataStatus = []
          this.formStatus.fail = 0
          this.formStatus.sucess = 0
          for (var key in this.dataItemImport) {
            console.log('key', typeof key)
            if (action === 'add') {
              await this.importDataAdd(this.dataItemImport[key])
              checkError = true
            }
          }
          console.log(checkError)
          if (checkError === true) {
            await this.getDataReward(
              this.DNS_IP,
              this.path,
              this.session.data.shopId,
              this.returnLink
            )
            this.dialogStatus = true
            this.dialogImportExcel = false
          } else {
            this.dataItemImport = []
            this.dataItemImportChecKHide = true
          }
          this.loading1 = false
        })
        .catch((error) => {
          console.log('error function importDataApprove : ', error)
          this.dataReady = true
        })
    },
    async importDataAdd (dt) {
      await axios
        .get(
          this.DNS_IP +
            '/rewardCode/get?rewardId=' +
            this.dataItem.rewardId +
            '&rewardCode=' +
            dt.rewardCode
        )
        .then(async (response) => {
          console.log('data', response)
          if (response.data.status === false) {
            this.formImport1.genType = 'excel'
            if (this.formImport1.rewardCode.toString().includes('/') === true) {
              this.formImport1.rewardCode = dt.rewardCode.replace(/\s/g, '')
            } else {
              this.formImport1.rewardCode = dt.rewardCode
            }
            this.formImport1.CREATE_USER = this.$session.getAll().data.userName
            this.formImport1.LAST_USER = this.$session.getAll().data.userName
            this.formImport1.rewardId = this.formUpdate.rewardId
            this.formImport1.redeemStatus = 'open'
            console.log('gdgdg', this.formImport1)
            await axios
              .post(this.DNS_IP + '/rewardCode/add', this.formImport1)
              .then(async (response) => {
                this.dialogImport = false
                this.formStatus.sucess = this.formStatus.sucess + 1
                this.formStatus.dataStatus.push({
                  rewardCode: dt.rewardCode,
                  status: 'True'
                })
              })
              .catch((error) => {
                // alert('โปรดใส่ไฟล์ให้ถูกต้อง', dt)
                console.log('error function importDataAdd addData : ', error)
                this.dataReady = true
              })
          } else {
            this.formStatus.fail = this.formStatus.fail + 1
            this.formStatus.dataStatus.push({
              rewardCode: dt.rewardCode,
              status: 'False'
            })
          }
        })
    },
    clearCreateCode () {
      this.formImport1.prefix = ''
      this.formImport1.count = 0
      this.formImport1.expireType = 'FixDate'
      this.formImport1.countExpire = 0
      this.formImport1.startDate = ''
      this.formImport1.endDate = ''
    }
  }
}
</script>
<style scoped>
.v-text-field {
  padding: 0px 15px !important;
}

.expire-reward {
  text-align: center;
  background-color: #ec7b7b;
  color: white;
  border-radius: 10px;
}

.theme--light.v-list-item:not(.v-list-item--active):not(
    .v-list-item--disabled
  ) {
  background-color: #fff !important;
}

.v-list-item__title {
  color: #000000 !important;
  font-family: "Kanit", sans-serif;
  font-weight: 400;
}

.v-list-item--active {
  background-color: #ffffff !important;
}

.v-stepper,
.v-stepper-header,
.v-stepper-items,
.v-stepper-content {
  box-shadow: none !important;
  border: none !important;
  background-color: transparent !important;
}

::v-deep(.v-stepper__step) {
  background-color: transparent !important;
  box-shadow: none !important;
  border: none !important;
}

::v-deep(.v-stepper__step__step),
::v-deep(.v-stepper__label) {
  background-color: transparent !important;
  color: #000;
  /* หรือสีที่คุณต้องการ */
  box-shadow: none !important;
}

.v-stepper,
.v-stepper__header {
  box-shadow: none !important;
  -webkit-box-shadow: none !important;
}

.v-dialog > .v-card > .v-card__actions {
  padding: 8px 24px;
}

.v-input--selection-controls {
  margin-top: none !important;
  padding-top: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Master/Reward.vue